// Geocoding - v6.xlsx file
const dataExample = {
  cityColumn: 8,
  coordinatesColumns: [3, 4],
  data: [
    [
      'id',
      'tmp_endereço',
      'formatted_address',
      'latitude',
      'longitude',
      'street_name',
      'street_number',
      'neighborhood',
      'city',
      'state',
      'zipcode',
    ],
    [
      '1',
      'Rua Botucaraí, 1840 - Bairro Centro - Candelária, RS/96930-000',
      'R. Botucarai, 1840 - Pôr-do-Sol, Candelária - RS, 96930-000, Brazil',
      '-29.6755612',
      '-52.7982653',
      'Rua Botucarai',
      '1840',
      'Pôr-do-Sol',
      'Candelária',
      'Rio Grande do Sul',
      '96930-000',
    ],
    [
      '2',
      'Rua Santo Antônio, 75 - Bairro Operario - Lagoa Vermelha, RS/95300-000',
      'Operário, Lagoa Vermelha - RS, 95300-000, Brazil',
      '-28.2265726',
      '-51.5152504',
      '',
      '',
      'Operário',
      'Lagoa Vermelha',
      'Rio Grande do Sul',
      '95300-000',
    ],
    [
      '3',
      'Cerro do Louro, SN - Bairro iIterior - Formigueiro, RS/97.210-000',
      'Cerro do Louro, Formigueiro - RS, 97210-000, Brazil',
      '-29.99476',
      '-53.615593',
      '',
      '',
      '',
      'Formigueiro',
      'Rio Grande do Sul',
      '97210-000',
    ],
    [
      '4',
      'Rua Anibal Xavier Bitencourt, 262 - Bairro Pinheiro - Caçapava do Sul, RS/96570-000',
      'Caçapava do Sul, RS, 96570-000, Brazil',
      '-30.5148445',
      '-53.4832383',
      '',
      '',
      '',
      'Caçapava do Sul',
      'Rio Grande do Sul',
      '96570-000',
    ],
    [
      '5',
      'Rua Helmott Klain, 41 - Bairro Planalto - Morro Reuter, RS/93990-000',
      'R. Planalto, 41, Morro Reuter - RS, 93990-000, Brazil',
      '-29.542451',
      '-51.0835851',
      'Rua Planalto',
      '41',
      '',
      'Morro Reuter',
      'Rio Grande do Sul',
      '93990-000',
    ],
    [
      '6',
      'Rua São Roque 431 - Bairro Moinhos - Estrela, RS/95880-000',
      'R. São Roque, 431 - Oriental, Estrela - RS, 95880-000, Brazil',
      '-29.4889309',
      '-51.9690079',
      'Rua São Roque',
      '431',
      'Oriental',
      'Estrela',
      'Rio Grande do Sul',
      '95880-000',
    ],
    [
      '7',
      'Rua José Montaury 963 - Bairro Centro - Veranópolis, RS/95330-000',
      'Av. Dr. José Montaury, 963 - Palugana, Veranópolis - RS, 95330-000, Brazil',
      '-28.9318491',
      '-51.55018399999999',
      'Avenida Doutor José Montaury',
      '963',
      'Palugana',
      'Veranópolis',
      'Rio Grande do Sul',
      '95330-000',
    ],
    [
      '8',
      'Avenida São João, 792 - Bairro Centro - São João do Polêsine, RS/97230-000',
      'Av. São João, 792, São João do Polêsine - RS, 97230-000, Brazil',
      '-29.6135784',
      '-53.4439316',
      'Avenida São João',
      '792',
      '',
      'São João do Polêsine',
      'Rio Grande do Sul',
      '97230-000',
    ],
    [
      '9',
      'Rua Constantino, SN - Bairro Interior - Progresso, RS/95925-000',
      'R. Frei Constantino, Progresso - RS, 95925-000, Brazil',
      '-29.2394661',
      '-52.3089942',
      'Rua Frei Constantino',
      '',
      '',
      'Progresso',
      'Rio Grande do Sul',
      '95925-000',
    ],
    [
      '10',
      'Rua feliz, 58 - Bairro Industrial - Farroupilha, RS/95180-000',
      'R. Feliz, 58 - Industrial, Farroupilha - RS, 95178-220, Brazil',
      '-29.231286',
      '-51.323443',
      'Rua Feliz',
      '58',
      'Industrial',
      'Farroupilha',
      'Rio Grande do Sul',
      '95178-220',
    ],
    [
      '11',
      'Rua Francisco Borges Vieira, 33 - Bairro Santa Teresinha - Vacaria, RS/95200-000',
      'R. Francisco Borges Vieira, 33 - Centro, Vacaria - RS, 95201-024, Brazil',
      '-28.5064802',
      '-50.9304594',
      'Rua Francisco Borges Vieira',
      '33',
      'Centro',
      'Vacaria',
      'Rio Grande do Sul',
      '95201-024',
    ],
    [
      '12',
      'Rua Quarenta e sete, SN - Bairro Jardim Algarve - Alvorada, RS/94858-670',
      'R. Quarenta e Sete - Jardim Algarve, Alvorada - RS, 94858-670, Brazil',
      '-30.0385149',
      '-51.0802783',
      'Rua Quarenta e Sete',
      '',
      'Jardim Algarve',
      'Alvorada',
      'Rio Grande do Sul',
      '94858-670',
    ],
    [
      '13',
      'BR 116, 410 - Bairro Picada - Eldorado do Sul, RS/92990-000',
      'BR-116, 410, Eldorado do Sul - RS, 92990-000, Brazil',
      '-29.9990734',
      '-51.2959',
      'BR-116',
      '410',
      '',
      'Eldorado do Sul',
      'Rio Grande do Sul',
      '92990-000',
    ],
    [
      '14',
      'Rua Paulo de Castro, 830 - Bairro Alesgut - Teutônia, RS/95890-000',
      'R. Paulo de Castro, 830, Teutônia - RS, 95890-000, Brazil',
      '-29.4714195',
      '-51.8307854',
      'Rua Paulo de Castro',
      '830',
      '',
      'Teutônia',
      'Rio Grande do Sul',
      '95890-000',
    ],
    [
      '15',
      'Rua Corredor do João, 53 - Bairro Faxinal - Santa Cruz do Sul, RS/96840-540',
      'R. Cel. João, 53 - Faxinal, Santa Cruz do Sul - RS, 96840-540, Brazil',
      '-29.7411776',
      '-52.4369395',
      'Rua Coronel João',
      '53',
      'Faxinal',
      'Santa Cruz do Sul',
      'Rio Grande do Sul',
      '96840-540',
    ],
    [
      '16',
      'Av Independência, 361 - Bairro Independência - Machadinho, RS/99880-000',
      'Av. Independência, 361 - Independência, Machadinho - RS, 99880-000, Brazil',
      '-27.5682901',
      '-51.6707891',
      'Avenida Independência',
      '361',
      'Independência',
      'Machadinho',
      'Rio Grande do Sul',
      '99880-000',
    ],
    [
      '17',
      'Rua Paulino Azurenha, 759 - Bairro Partenon - Porto Alegre, RS/90680-240',
      'R. Paulino Azurenha, 759 - Partenon, Porto Alegre - RS, 90680-240, Brazil',
      '-30.06659149999999',
      '-51.194872',
      'Rua Paulino Azurenha',
      '759',
      'Partenon',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90680-240',
    ],
    [
      '18',
      'Rua General Neto, 228 - Bairro Centro - Bagé, RS/96400-380',
      'R. Gen. Neto, 228 - Centro, Bagé - RS, 96400-021, Brazil',
      '-31.3302778',
      '-54.1022741',
      'Rua General Neto',
      '228',
      'Centro',
      'Bagé',
      'Rio Grande do Sul',
      '96400-021',
    ],
    [
      '19',
      'Rua Soldado Enites da Silva Rodrigues, 111 - Bairro Vila Militar - Rio Grande - 96201-270',
      'Rua Soldado Enites of Silva Rodrigues, 111 - Vila Militar, Rio Grande - RS, 96201-280, Brazil',
      '-32.0343157',
      '-52.08300209999999',
      'Rua Soldado Enites of Silva Rodrigues',
      '111',
      'Vila Militar',
      'Rio Grande',
      'Rio Grande do Sul',
      '96201-280',
    ],
    [
      '20',
      'Linha Barra do Araca, 0 - São Luís Gonzaga,RS/ 97800000',
      'São Luiz Gonzaga - RS, 97800-000, Brazil',
      '-28.40818',
      '-54.9615405',
      '',
      '',
      '',
      'São Luiz Gonzaga',
      'Rio Grande do Sul',
      '97800-000',
    ],
    [
      '21',
      'Rua Justino Martins, 70 - Bairro Mário Quintana - Porto Alegre, RS/ 91260330',
      'R. Justino Martins, 70 - Alto Petrópolis, Porto Alegre - RS, 91260-330, Brazil',
      '-30.03693489999999',
      '-51.1038416',
      'Rua Justino Martins',
      '70',
      'Alto Petrópolis',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91260-330',
    ],
    [
      '22',
      'Rua São Roque 431 - Bairro Moinhos - Estrela, RS/95880-000',
      'R. São Roque, 431 - Oriental, Estrela - RS, 95880-000, Brazil',
      '-29.4889309',
      '-51.9690079',
      'Rua São Roque',
      '431',
      'Oriental',
      'Estrela',
      'Rio Grande do Sul',
      '95880-000',
    ],
    [
      '23',
      'Av. Wenceslau Escobar, 1086, ap 217 - Bairro Cristal - Porto Alegre, RS - 91900000',
      'Av. Wenceslau Escobar, 1086 - 217 - Cristal, Porto Alegre - RS, 91900-000, Brazil',
      '-30.099674',
      '-51.248311',
      'Avenida Wenceslau Escobar',
      '1086',
      'Cristal',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91900-000',
    ],
    [
      '24',
      'Rua Érico Guilherme Sauler, 667 - Bairro Novo Paraíso - Estrela, RS - 95880-000',
      'R. Érico Veríssimo - Cristo Rei, Estrela - RS, 95880-000, Brazil',
      '-29.5092569',
      '-51.9691601',
      'Rua Érico Veríssimo',
      '',
      'Cristo Rei',
      'Estrela',
      'Rio Grande do Sul',
      '95880-000',
    ],
    [
      '25',
      'Rua Juscelino Kubitschek de Oliveira, 705 - Bairro Parque Branja Esperança - Cachoeirinha, RS - 94960-370',
      'R. Juscelino Kubitschek de Oliveira, 705 - Parque Granja Esperanca, Cachoeirinha - RS, 94960-370, Brazil',
      '-29.9083261',
      '-51.0791774',
      'Rua Juscelino Kubitschek de Oliveira',
      '705',
      'Parque Granja Esperanca',
      'Cachoeirinha',
      'Rio Grande do Sul',
      '94960-370',
    ],
    [
      '26',
      'rua Alberto Pasqualini, 589 - bairro Marrocos - Gravataí - 94045-190',
      'R. Alberto Pasqualini, 589 - Marrocos, Gravataí - RS, 94045-190, Brazil',
      '-29.9420238',
      '-51.0224938',
      'Rua Alberto Pasqualini',
      '589',
      'Marrocos',
      'Gravataí',
      'Rio Grande do Sul',
      '94045-190',
    ],
    [
      '27',
      'Av. Professora Paula Soares, 213 - bairro Jardim Itu Sabará - Porto Alegre - 91220-450',
      'Av. Prof. Paula Soares, 213 - Jardim Itu-Sabará, Porto Alegre - RS, 91220-450, Brazil',
      '-30.0125444',
      '-51.1384492',
      'Avenida Professor Paula Soares',
      '213',
      'Jardim Itu-Sabará',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91220-450',
    ],
    [
      '28',
      'R DOS IPES B: QUATRO LAGOS,521- ARROIO DO SAL',
      'R. dos Ipês, Arroio do Sal - RS, 95585-000, Brazil',
      '-29.5405077',
      '-49.8970321',
      'Rua dos Ipês',
      '',
      '',
      'Arroio do Sal',
      'Rio Grande do Sul',
      '95585-000',
    ],
    [
      '29',
      'R DOS IPES B: QUATRO LAGOS,521- ARROIO DO SAL',
      'R. dos Ipês, Arroio do Sal - RS, 95585-000, Brazil',
      '-29.5405077',
      '-49.8970321',
      'Rua dos Ipês',
      '',
      '',
      'Arroio do Sal',
      'Rio Grande do Sul',
      '95585-000',
    ],
    [
      '30',
      'rua Virgílio Lorenzi, 844 - bairro Lorenzi - Santa Maria - 97070-705',
      'R. Virgílio Lorensi, 844 - Lorenzi, Santa Maria - RS, 97070, Brazil',
      '-29.7307861',
      '-53.8126117',
      'Rua Virgílio Lorensi',
      '844',
      'Lorenzi',
      'Santa Maria',
      'Rio Grande do Sul',
      '97070',
    ],
    [
      '31',
      'RUA ERNESTO SANTOS VIVIAN,268-TRÊS PASSOS/RS, 98600000',
      'Três Passos, RS, 98600-000, Brazil',
      '-27.4559325',
      '-53.9301575',
      '',
      '',
      '',
      'Três Passos',
      'Rio Grande do Sul',
      '98600-000',
    ],
    [
      '32',
      'RUA ANTÔNIO MARIANTE ,61,CENTRO,ELDORADO DO SUL,RS/92900000',
      'R. Antônio Mariante, 61 - Centro, Eldorado do Sul - RS, 92990-000, Brazil',
      '-29.9942499',
      '-51.31207029999999',
      'Rua Antônio Mariante',
      '61',
      'Centro',
      'Eldorado do Sul',
      'Rio Grande do Sul',
      '92990-000',
    ],
    [
      '33',
      'rua Jornalista Arquimedes Fortini, 580 - bairro Maria de Fátima - Rio Grande/96200-000',
      'R. Jorn. Arquimedes Fortini, 580 - Vila Nossa Sra. de Fatima, Rio Grande - RS, 96213-400, Brazil',
      '-32.0677064',
      '-52.1772747',
      'Rua Jornalista Arquimedes Fortini',
      '580',
      'Vila Nossa Senhora de Fatima',
      'Rio Grande',
      'Rio Grande do Sul',
      '96213-400',
    ],
    [
      '34',
      'rua Analdelino R. de Souza - bairro Fenamate - Coronel Bicaco - 98580-000',
      'Parque Da Fenamate - 1015, Av. Salgado Filho, 735, Cel. Bicaco - RS, 98580-000, Brazil',
      '-27.7222015',
      '-53.7166073',
      'Avenida Salgado Filho',
      '735',
      '',
      'Coronel Bicaco',
      'Rio Grande do Sul',
      '98580-000',
    ],
    [
      '35',
      'RUA Caetano gonçalves, 1323 - Centro - Bagé/96400-040',
      'R. Caetano Gonçalves, 1323 - Centro, Bagé - RS, 96400-040, Brazil',
      '-31.325387',
      '-54.1002398',
      'Rua Caetano Gonçalves',
      '1323',
      'Centro',
      'Bagé',
      'Rio Grande do Sul',
      '96400-040',
    ],
    [
      '36',
      'rua Desalmo Pedro Klein - bairro Lajeadinho - São Sebastião do Caí',
      'R. Treze de Maio, 849, São Sebastião do Caí - RS, 95760-000, Brazil',
      '-29.588995',
      '-51.374274',
      'Rua Treze de Maio',
      '849',
      '',
      'São Sebastião do Caí',
      'Rio Grande do Sul',
      '95760-000',
    ],
    [
      37,
      'rua Tais de Souza , 235, Viamão, 94510-344, Rio Grande do Sul',
      'R. Taís de Souza, 235 - Vila Augusta, Viamão - RS, 94510-344, Brazil',
      '-30.0680527',
      '-51.080608',
      'Rua Taís de Souza',
      '235',
      'Vila Augusta',
      'Viamão',
      'Rio Grande do Sul',
      '94510-344',
    ],
    [
      38,
      'Esquina Guia Lopes, 2709, Santa Rosa, 98900-000, Rio Grande do Sul',
      'R. Estrela Guia, Santa Rosa - RS, Brazil',
      '-27.8629644',
      '-54.4464158',
      'Rua Estrela Guia',
      '',
      '',
      'Santa Rosa',
      'Rio Grande do Sul',
      '',
    ],
    [
      39,
      'Rio Seco, Três Cachoeiras     , 95580-000, Rio Grande do Sul',
      'R. Rio Seco, Três Cachoeiras - RS, 95580-000, Brazil',
      '-29.4134723',
      '-49.97775300000001',
      'Rua Rio Seco',
      '',
      '',
      'Três Cachoeiras',
      'Rio Grande do Sul',
      '95580-000',
    ],
    [
      40,
      'Rua Dea Coufal, 878, Porto Alegre, 91760-020, Rio Grande do Sul',
      'R. Déa Coufal, 878 - Ipanema, Porto Alegre - RS, 91760-020, Brazil',
      '-30.1291914',
      '-51.2284474',
      'Rua Déa Coufal',
      '878',
      'Ipanema',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91760-020',
    ],
    [
      41,
      'Linha Italiana, Cerro Grande do Sul, 96770-000, Rio Grande do Sul',
      'Cerro Grande do Sul - RS, 96770-000, Brazil',
      '-30.5966455',
      '-51.7518126',
      '',
      '',
      '',
      'Cerro Grande do Sul',
      'Rio Grande do Sul',
      '96770-000',
    ],
    [
      42,
      'rua da Pereira,13170, Igrejinha, 95650-000, Rio Grande do Sul',
      'R. da Pereira - Rothmann, Igrejinha - RS, 95650-000, Brazil',
      '-29.5475556',
      '-50.7790831',
      'Rua da Pereira',
      '',
      'Rothmann',
      'Igrejinha',
      'Rio Grande do Sul',
      '95650-000',
    ],
    [
      43,
      'rua Sarandi, 155, Canoas, 92330-260, Rio Grande do Sul',
      'R. Sarandi, 155 - Mathias Velho, Canoas - RS, 92330-260, Brazil',
      '-29.902191',
      '-51.22264',
      'Rua Sarandi',
      '155',
      'Mathias Velho',
      'Canoas',
      'Rio Grande do Sul',
      '92330-260',
    ],
    [
      44,
      'rua Telmo Sessim, 1607, Capivari do Sul     , 95552-971, Rio Grande do Sul',
      'Av. Telmo Sessim, 1607, Capivari do Sul - RS, 95552-000, Brazil',
      '-30.1473627',
      '-50.5122459',
      'Avenida Telmo Sessim',
      '1607',
      '',
      'Capivari do Sul',
      'Rio Grande do Sul',
      '95552-000',
    ],
    [
      45,
      'Rincão Vermelho, Roque Gonzales, 97975-000, Rio Grande do Sul',
      'Rincão Vermelho, Roque Gonzales - RS, 97970-000, Brazil',
      '-27.9535859',
      '-55.2746252',
      '',
      '',
      '',
      'Roque Gonzales',
      'Rio Grande do Sul',
      '97970-000',
    ],
    [
      46,
      'Assentamento Passo Real , Pontão, 99190-000, Rio Grande do Sul',
      'Passo Real, Salto do Jacuí - RS, 99440-000, Brazil',
      '-29.040625',
      '-53.171569',
      '',
      '',
      '',
      'Salto do Jacuí',
      'Rio Grande do Sul',
      '99440-000',
    ],
    [
      47,
      'Rua Saturnino Vanzelotti,20/101, Porto Alegre, 91170-640, Rio Grande do Sul',
      'Rua Saturnino Vanzelotti, 20 - Rubem Berta, Porto Alegre - RS, 91170-640, Brazil',
      '-30.00530819999999',
      '-51.0971213',
      'Rua Saturnino Vanzelotti',
      '20',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91170-640',
    ],
    [
      48,
      'Rua Jacob Milton Benemann,456, Sapiranga    , 93800-000, Rio Grande do Sul',
      'R. Jacob Milton Benemann, 456 - Sete de Setembro, Sapiranga - RS, 93815-016, Brazil',
      '-29.6365868',
      '-50.9809911',
      'Rua Jacob Milton Benemann',
      '456',
      'Sete de Setembro',
      'Sapiranga',
      'Rio Grande do Sul',
      '93815-016',
    ],
    [
      49,
      'Rua Eng. Leopoldo Vila Nova,875, Passo Fundo , 99070-180, Rio Grande do Sul',
      'R. Leopoldo Vila Nova, 875 - Vila Santa Maria, Passo Fundo - RS, 99070-180, Brazil',
      '-28.2671982',
      '-52.3782716',
      'Rua Leopoldo Vila Nova',
      '875',
      'Vila Santa Maria',
      'Passo Fundo',
      'Rio Grande do Sul',
      '99070-180',
    ],
    [
      50,
      'Rua Humberto Lampert, 80, Carazinho     , 99500-000, Rio Grande do Sul',
      'R. Humberto Lamperti, 80 - Rica, Carazinho - RS, 99500-000, Brazil',
      '-28.3025454',
      '-52.7811645',
      'Rua Humberto Lamperti',
      '80',
      'Rica',
      'Carazinho',
      'Rio Grande do Sul',
      '99500-000',
    ],
    [
      51,
      'Rua Angola, 132, Panambi         , 98280-000, Rio Grande do Sul',
      'R. Angola, 132 - Arco-Íris, Panambi - RS, 98280-000, Brazil',
      '-28.3154501',
      '-53.50300739999999',
      'Rua Angola',
      '132',
      'Arco-Íris',
      'Panambi',
      'Rio Grande do Sul',
      '98280-000',
    ],
    [
      52,
      'CoLônia de Santo Antonio, Pelotas , 96065-460, Rio Grande do Sul',
      'R. Santo Antônio - Py Crespo, Pelotas - RS, 96065-460, Brazil',
      '-31.7249222',
      '-52.346447',
      'Rua Santo Antônio',
      '',
      'Py Crespo',
      'Pelotas',
      'Rio Grande do Sul',
      '96065-460',
    ],
    [
      53,
      'Rua Lauro Ribeiro Travessa 3 , 69, Pelotas , 96050-480, Rio Grande do Sul',
      'R. Lauro Ribeiro, 3 - Fragata, Pelotas - RS, 96050-480, Brazil',
      '-31.7313373',
      '-52.390029',
      'Rua Lauro Ribeiro',
      '3',
      'Fragata',
      'Pelotas',
      'Rio Grande do Sul',
      '96050-480',
    ],
    [
      54,
      'Linha Quatro, Ibirubá , 98200-000, Rio Grande do Sul',
      'Ibirubá - RS, 98200-000, Brazil',
      '-28.6308108',
      '-53.09559119999999',
      '',
      '',
      '',
      'Ibirubá',
      'Rio Grande do Sul',
      '98200-000',
    ],
    [
      55,
      'Interior, Nova Bréscia, 95950-000, Rio Grande do Sul',
      'Nova Bréscia, RS, 95950-000, Brazil',
      '-29.2148564',
      '-52.0265488',
      '',
      '',
      '',
      'Nova Bréscia',
      'Rio Grande do Sul',
      '95950-000',
    ],
    [
      56,
      'Rua Projetada F, 71, Guaíba , 92500-000, Rio Grande do Sul',
      'R. Projetada F - Flórida, Guaíba - RS, 92500-000, Brazil',
      '-30.1519738',
      '-51.3330287',
      'Rua Projetada F',
      '',
      'Flórida',
      'Guaíba',
      'Rio Grande do Sul',
      '92500-000',
    ],
    [
      57,
      'Rua Saudade, 0, Harmonia, 95785-000, Rio Grande do Sul',
      'Rua Jacob Weissheimer Sobrinho, 56 - Centro, Harmonia - RS, 95785-000, Brazil',
      '-29.5522424',
      '-51.4167761',
      'Rua Jacob Weissheimer Sobrinho',
      '56',
      'Centro',
      'Harmonia',
      'Rio Grande do Sul',
      '95785-000',
    ],
    [
      58,
      'Rua Barão do Rio Branco, 1235, Osório, 95520-000, Rio Grande do Sul',
      'R. Barão do Rio Branco, 1235 - Centro, Osório - RS, 95520-000, Brazil',
      '-29.8960845',
      '-50.2669404',
      'Rua Barão do Rio Branco',
      '1235',
      'Centro',
      'Osório',
      'Rio Grande do Sul',
      '95520-000',
    ],
    [
      59,
      'Rua da Participação, 28, Novo Hamburgo, 93530-300, Rio Grande do Sul',
      'R. da Participação, 28 - Vila Diehl, Novo Hamburgo - RS, 93530-300, Brazil',
      '-29.6515532',
      '-51.1115082',
      'Rua da Participação',
      '28',
      'Vila Diehl',
      'Novo Hamburgo',
      'Rio Grande do Sul',
      '93530-300',
    ],
    [
      60,
      'Linha Espinilho, São Pedro das Missões, 98323-000, Rio Grande do Sul',
      'São Pedro das Missões, RS, 98323-000, Brazil',
      '-27.7716237',
      '-53.2558458',
      '',
      '',
      '',
      'São Pedro das Missões',
      'Rio Grande do Sul',
      '98323-000',
    ],
    [
      61,
      'Rua Manoel Francisco Anflor, 65, Osório, 95520-000, Rio Grande do Sul',
      'R. Manoel F Anflor, 65 - Laranjeiras, Osório - RS, 95520-000, Brazil',
      '-29.896913',
      '-50.3050633',
      'Rua Manoel F Anflor',
      '65',
      'Laranjeiras',
      'Osório',
      'Rio Grande do Sul',
      '95520-000',
    ],
    [
      62,
      'rua Quinze de Novembro, 144, Nova Ramada, 98758-000, Rio Grande do Sul',
      'Avenida Gustavo Konig, 332 - Centro, Nova Ramada - RS, 98758-000, Brazil',
      '-28.0828513',
      '-53.70740499999999',
      'Avenida Gustavo Konig',
      '332',
      'Centro',
      'Nova Ramada',
      'Rio Grande do Sul',
      '98758-000',
    ],
    [
      63,
      'Baixo Passa Sete, Passa Sete, 96901-000, Rio Grande do Sul',
      'Estr. Baixo Passa Sete, Passa Sete - RS, 96908-000, Brazil',
      '-29.484664',
      '-52.9229478',
      'Estrada Baixo Passa Sete',
      '',
      '',
      'Passa Sete',
      'Rio Grande do Sul',
      '96908-000',
    ],
    [
      64,
      'Men de Sá, 188, Alvorada, 94828-510, Rio Grande do Sul',
      'R. Men de Sá, 188 - Maria Regina, Alvorada - RS, 94828-510, Brazil',
      '-29.9983254',
      '-51.0592507',
      'Rua Men de Sá',
      '188',
      'Maria Regina',
      'Alvorada',
      'Rio Grande do Sul',
      '94828-510',
    ],
    [
      65,
      ', Cambará do Sul, 95480-000, Rio Grande do Sul',
      'Cambará do Sul - RS, 95480-000, Brazil',
      '-28.9809591',
      '-50.1009527',
      '',
      '',
      '',
      'Cambará do Sul',
      'Rio Grande do Sul',
      '95480-000',
    ],
    [
      66,
      'Brasil, 98, Encantado, 95960-000, Rio Grande do Sul',
      'R. Rio Grande do Sul, 98 - Santa Clara, Encantado - RS, 95960-000, Brazil',
      '-29.2495153',
      '-51.8757988',
      'Rua Rio Grande do Sul',
      '98',
      'Santa Clara',
      'Encantado',
      'Rio Grande do Sul',
      '95960-000',
    ],
    [
      67,
      'São Luis,1194, Porto Alegre, 90620-170, Rio Grande do Sul',
      'R. São Luís, 1194 - Petrópolis, Porto Alegre - RS, 90470-440, Brazil',
      '-30.0529902',
      '-51.2005267',
      'Rua São Luís',
      '1194',
      'Petrópolis',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90470-440',
    ],
    [
      68,
      'Canoas, 929, Dois Irmãos, 95995-000, Rio Grande do Sul',
      'Av. São Miguel, 1286 - Floresta, Dois Irmãos - RS, 93950-000, Brazil',
      '-29.5812545',
      '-51.0865936',
      'Avenida São Miguel',
      '1286',
      'Floresta',
      'Dois Irmãos',
      'Rio Grande do Sul',
      '93950-000',
    ],
    [
      69,
      'Waltoir Jose da Silva, 736, Gravatai, 94180-020, Rio Grande do Sul',
      'R. Waltoir José da Silva, 736 - Parque dos Anjos, Gravataí - RS, 94180-020, Brazil',
      '-29.9317187',
      '-50.9543434',
      'Rua Waltoir José da Silva',
      '736',
      'Parque dos Anjos',
      'Gravataí',
      'Rio Grande do Sul',
      '94180-020',
    ],
    [
      70,
      'João Alfredo Renck, 71, Igrejinha, 95650-000, Rio Grande do Sul',
      'R. João Alfredo Renck, 71 - Bom Pastor, Igrejinha - RS, 95650-000, Brazil',
      '-29.56929209999999',
      '-50.8045891',
      'Rua João Alfredo Renck',
      '71',
      'Bom Pastor',
      'Igrejinha',
      'Rio Grande do Sul',
      '95650-000',
    ],
    [
      71,
      'Darci Marques da Silva, 103 Mapa II, Porto Alegre, 91550-450, Rio Grande do Sul',
      'R. Darcí Marquês da Silva, 103 - Lomba do Pinheiro, Porto Alegre - RS, 91550-450, Brazil',
      '-30.0961912',
      '-51.1315713',
      'Rua Darcí Marquês da Silva',
      '103',
      'Lomba do Pinheiro',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91550-450',
    ],
    [
      72,
      'Fagundes Varella, 449, Estancia Velha, 93600-000, Rio Grande do Sul',
      'R. Fagundes Varela, 449 - Das Rosas, Estância Velha - RS, 93600-470, Brazil',
      '-29.6507371',
      '-51.1669881',
      'Rua Fagundes Varela',
      '449',
      'Das Rosas',
      'Estância Velha',
      'Rio Grande do Sul',
      '93600-470',
    ],
    [
      73,
      'João de Cesaro, 42, Passo Fundo, 99070-140, Rio Grande do Sul',
      'R. João de Cesaro, 42 - Vila Rodrigues, Passo Fundo - RS, 99070-140, Brazil',
      '-28.259223',
      '-52.3982685',
      'Rua João de Cesaro',
      '42',
      'Vila Rodrigues',
      'Passo Fundo',
      'Rio Grande do Sul',
      '99070-140',
    ],
    [
      74,
      'Limoeiro, 246, São Leopoldo , 93115-510, Rio Grande do Sul',
      'R. Limoeiro - Santos Dumont, São Leopoldo - RS, 93115-510, Brazil',
      '-29.7196254',
      '-51.1455531',
      'Rua Limoeiro',
      '',
      'Santos Dumont',
      'São Leopoldo',
      'Rio Grande do Sul',
      '93115-510',
    ],
    [
      75,
      'São João, 637, Canela, 95680-000, Rio Grande do Sul',
      'R. São João, 637 - Vale Verde, Canela - RS, 95680-000, Brazil',
      '-29.356384',
      '-50.7959724',
      'Rua São João',
      '637',
      'Vale Verde',
      'Canela',
      'Rio Grande do Sul',
      '95680-000',
    ],
    [
      76,
      'Manoel Faria da Rosa Primo, 22, Porto Alegre, 91790-770, Rio Grande do Sul',
      'R. Manoel Faria da Rosa Primo - Restinga, Porto Alegre - RS, 91790-770, Brazil',
      '-30.1592646',
      '-51.1390881',
      'Rua Manoel Faria da Rosa Primo',
      '',
      'Restinga',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91790-770',
    ],
    [
      77,
      'Elvis Presley, 100, Gravatai, 94110-604, Rio Grande do Sul',
      'Rua Elvis Presley, 100 - Vera Cruz, Gravataí - RS, 94090-010, Brazil',
      '-29.9207867',
      '-51.0467462',
      'Rua Elvis Presley',
      '100',
      'Vera Cruz',
      'Gravataí',
      'Rio Grande do Sul',
      '94090-010',
    ],
    [
      78,
      'Av. Frei Junipero Serra, 142, Passo Fundo, 99062-385, Rio Grande do Sul',
      'Av. Frei Junipero Serra, 142 - São Cristovao, Passo Fundo - RS, 99062-385, Brazil',
      '-28.283642',
      '-52.374584',
      'Avenida Frei Junipero Serra',
      '142',
      'São Cristovao',
      'Passo Fundo',
      'Rio Grande do Sul',
      '99062-385',
    ],
    [
      79,
      'Giacomo Bisol, 51, Caxias do Sul, 95000-000, Rio Grande do Sul',
      'Estr. Mun. Giácomo Bisol, 51 - São Luiz, Caxias do Sul - RS, 95074, Brazil',
      '-29.1688447',
      '-51.1234028',
      'Estrada Municipal Giácomo Bisol',
      '51',
      'São Luiz',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95074',
    ],
    [
      80,
      'Jornalista Tulio Fontoura, 258, Passo Fundo, 99064-000, Rio Grande do Sul',
      'R. Jorn. Túlio Fontoura, 258 - São Cristovao, Passo Fundo - RS, 99064-200, Brazil',
      '-28.2855257',
      '-52.3659184',
      'Rua Jornalista Túlio Fontoura',
      '258',
      'São Cristovao',
      'Passo Fundo',
      'Rio Grande do Sul',
      '99064-200',
    ],
    [
      81,
      'Vacacaí, 110, Porto Alegre, 91712-011, Rio Grande do Sul',
      'Rua Vacacaí, 110 - Belém Velho, Porto Alegre - RS, 91712-011, Brazil',
      '-30.1018486',
      '-51.1706122',
      'Rua Vacacaí',
      '110',
      'Belém Velho',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91712-011',
    ],
    [
      82,
      'Otavo, 153, Novo Hamburgo, 93420-548, Rio Grande do Sul',
      'R. Otávio Alves Ourique, 153 - Canudos, Novo Hamburgo - RS, Brazil',
      '-29.6960108',
      '-51.0858006',
      'Rua Otávio Alves Ourique',
      153,
      'Canudos',
      'Novo Hamburgo',
      'Rio Grande do Sul',
      '',
    ],
    [
      83,
      'Av. Esperança II, 27, Canoas, 92440-614, Rio Grande do Sul',
      'Esperanca 2 - Ne - São José, Canoas - RS, 92440-614, Brazil',
      '-29.891047',
      '-51.141148',
      '',
      '',
      'São José',
      'Canoas',
      'Rio Grande do Sul',
      '92440-614',
    ],
    [
      84,
      'Laguna, 88, Três Passos, 98600-000, Rio Grande do Sul',
      'R. Laguna, 88 - Centro, Três Passos - RS, 98600-000, Brazil',
      '-27.4538017',
      '-53.9271823',
      'Rua Laguna',
      '88',
      'Centro',
      'Três Passos',
      'Rio Grande do Sul',
      '98600-000',
    ],
    [
      85,
      'Av. Serafin Machado, 245, Porto Alegre, 91250-105, Rio Grande do Sul',
      'Av. Serafim Machado, 245 - Alto Petrópolis, Porto Alegre - RS, 91250-105, Brazil',
      '-30.0280821',
      '-51.1033615',
      'Avenida Serafim Machado',
      '245',
      'Alto Petrópolis',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91250-105',
    ],
    [
      86,
      'Rudy Merten, 327, Vera Cruz, 96880-000, Rio Grande do Sul',
      'R. Rudy Merten, 327 - Boa Vista, Vera Cruz - RS, 96880-000, Brazil',
      '-29.7111281',
      '-52.5237648',
      'Rua Rudy Merten',
      '327',
      'Boa Vista',
      'Vera Cruz',
      'Rio Grande do Sul',
      '96880-000',
    ],
    [
      87,
      'São Pedro do Iraxin s/n, São José do Ouro, 99870-000, Rio Grande do Sul',
      'São Pedro do Iraxim, São José do Ouro - RS, 99870-000, Brazil',
      '-27.6899678',
      '-51.6157348',
      '',
      '',
      '',
      'São José do Ouro',
      'Rio Grande do Sul',
      '99870-000',
    ],
    [
      88,
      'Vila Silva - 3° Distrito , Canguçu, 96600-000, Rio Grande do Sul',
      'Vila Silva, Canguçu - RS, 96600-000, Brazil',
      '-31.2777373',
      '-52.7636889',
      'Vila Silva',
      '',
      '',
      'Canguçu',
      'Rio Grande do Sul',
      '96600-000',
    ],
    [
      89,
      'Major Hermes Pereira,1922, Venâncio Aires, 95800-000, Rio Grande do Sul',
      'R. Maj. Hermes Pereira, 1922 - Gressler, Venâncio Aires - RS, 95800-000, Brazil',
      '-29.6154131',
      '-52.20700040000001',
      'Rua Major Hermes Pereira',
      '1922',
      'Gressler',
      'Venâncio Aires',
      'Rio Grande do Sul',
      '95800-000',
    ],
    [
      90,
      'Operário,85, Novo Hamburgo, 93420-548, Rio Grande do Sul',
      'R. Nazaré - Santo Afonso, Novo Hamburgo - RS, 93420-548, Brazil',
      '-29.7332747',
      '-51.1286499',
      'Rua Nazaré',
      '',
      'Santo Afonso',
      'Novo Hamburgo',
      'Rio Grande do Sul',
      '93420-548',
    ],
    [
      91,
      'Vidal Negreiros,371, Canoas, 92200-530, Rio Grande do Sul',
      'R. Vidal de Negreiros, 371 - Rio Branco, Canoas - RS, 92200-530, Brazil',
      '-29.9632237',
      '-51.19390600000001',
      'Rua Vidal de Negreiros',
      '371',
      'Rio Branco',
      'Canoas',
      'Rio Grande do Sul',
      '92200-530',
    ],
    [
      92,
      'Crespim Demozzi, 59, Bento Gonçalves, 95700-630, Rio Grande do Sul',
      'Av. Osvaldo Aranha, 540 - Juventude da Enologia, Bento Gonçalves - RS, 95700-000, Brazil',
      '-29.1637544',
      '-51.52269500000001',
      'Avenida Osvaldo Aranha',
      '540',
      'Juventude da Enologia',
      'Bento Gonçalves',
      'Rio Grande do Sul',
      '95700-000',
    ],
    [
      93,
      'Antonio Monteiro da Costa, Osório, 95520-000, Rio Grande do Sul',
      'R. Antonio Monteiro da Costa - Farroupilha, Osório - RS, 95520-000, Brazil',
      '-29.894544',
      '-50.24666269999999',
      'Rua Antonio Monteiro da Costa',
      '',
      'Farroupilha',
      'Osório',
      'Rio Grande do Sul',
      '95520-000',
    ],
    [
      94,
      ', Vacaria, 95200-959, Rio Grande do Sul',
      'Vacaria, RS, 95200-000, Brazil',
      '-28.5071196',
      '-50.941176',
      '',
      '',
      '',
      'Vacaria',
      'Rio Grande do Sul',
      '95200-000',
    ],
    [
      95,
      'Reinaldo Safran, Lajeado, 95903-610, Rio Grande do Sul',
      'Lajeado, RS, Brazil',
      '-29.459582',
      '-51.96494209999999',
      '',
      '',
      '',
      'Lajeado',
      'Rio Grande do Sul',
      '',
    ],
    [
      96,
      'Vila Manchincha, Três de Maio, 98210-000, Rio Grande do Sul',
      'Manchinha, Três de Maio - RS, 98910-000, Brazil',
      '-27.6906821',
      '-54.22537269999999',
      '',
      '',
      '',
      'Três de Maio',
      'Rio Grande do Sul',
      '98910-000',
    ],
    [
      97,
      'Elizeu Peres, 100, Pinheiro Machado, 96470-00, Rio Grande do Sul',
      'R. Elizeu Idio Péres, 100, Pinheiro Machado - RS, 96470-000, Brazil',
      '-31.5826552',
      '-53.3841936',
      'Rua Elizeu Idio Péres',
      '100',
      '',
      'Pinheiro Machado',
      'Rio Grande do Sul',
      '96470-000',
    ],
    [
      98,
      'Rio Guaíba, 81, Gravataí, 94197-264, Rio Grande do Sul',
      'R. Rio Guaíba, 81 - Parque do Itatiaia, Gravataí - RS, 94197, Brazil',
      '-29.9218324',
      '-50.9352696',
      'Rua Rio Guaíba',
      '81',
      'Parque do Itatiaia',
      'Gravataí',
      'Rio Grande do Sul',
      '94197',
    ],
    [
      99,
      'Ipamoriti,254, São Leopoldo, 93130-752, Rio Grande do Sul',
      'R. Ipamoriti, 254 - Campina, São Leopoldo - RS, 93130-752, Brazil',
      '-29.7494039',
      '-51.1655762',
      'Rua Ipamoriti',
      '254',
      'Campina',
      'São Leopoldo',
      'Rio Grande do Sul',
      '93130-752',
    ],
    [
      100,
      'João Luis Malheiros,98, Panambi, 98280-000, Rio Grande do Sul',
      'R. João Luís Malheiros, 98 - Arco-Íris, Panambi - RS, 98280-000, Brazil',
      '-28.3148897',
      '-53.513712',
      'Rua João Luís Malheiros',
      '98',
      'Arco-Íris',
      'Panambi',
      'Rio Grande do Sul',
      '98280-000',
    ],
    [
      101,
      'Júlio de Castilhos, 1578, Sananduva, 99840-000, Rio Grande do Sul',
      'Av. Júlio de Castilhos, 1578, Sananduva - RS, 99840-000, Brazil',
      '-27.9616607',
      '-51.7944589',
      'Avenida Júlio de Castilhos',
      '1578',
      '',
      'Sananduva',
      'Rio Grande do Sul',
      '99840-000',
    ],
    [
      102,
      'Antonio Simon, 130, Butiá, 96750-000, Rio Grande do Sul',
      'R. Antônio Dessimon - Cidade Baixa, Butiá - RS, 96750-000, Brazil',
      '-30.1133979',
      '-51.9622936',
      'Rua Antônio Dessimon',
      '',
      'Cidade Baixa',
      'Butiá',
      'Rio Grande do Sul',
      '96750-000',
    ],
    [
      103,
      'Godofredo Raimundo, 1129, CAnela, 95680-000, Rio Grande do Sul',
      'R. Godofredo Raimundo, 1129 - Eugênio Ferreira, Canela - RS, 95680-000, Brazil',
      '-29.36668',
      '-50.7949349',
      'Rua Godofredo Raimundo',
      '1129',
      'Eugênio Ferreira',
      'Canela',
      'Rio Grande do Sul',
      '95680-000',
    ],
    [
      104,
      'Linha São Caetano, São Jorge, 95365-000, Rio Grande do Sul',
      'Av. Daltro Filho, 901, São Jorge - RS, 95365-000, Brazil',
      '-28.4999614',
      '-51.7042323',
      'Avenida Daltro Filho',
      '901',
      '',
      'São Jorge',
      'Rio Grande do Sul',
      '95365-000',
    ],
    [
      105,
      'rua Monte Líbano, 1131, Bagé, 96400-550, Rio Grande do Sul',
      'R. Monte Líbano, 1131 - Getúlio Vargas, Bagé - RS, 96412-730, Brazil',
      '-31.308545',
      '-54.0962669',
      'Rua Monte Líbano',
      '1131',
      'Getúlio Vargas',
      'Bagé',
      'Rio Grande do Sul',
      '96412-730',
    ],
    [
      106,
      'Av do Forte, 1894/602, Porto Alegre, 91360-000, Rio Grande do Sul',
      'Av. do Forte, 1894 - Vila Ipiranga, Porto Alegre - RS, 91360-001, Brazil',
      '-30.02733749999999',
      '-51.1505664',
      'Avenida do Forte',
      '1894',
      'Vila Ipiranga',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91360-001',
    ],
    [
      107,
      'Salvador Nunes Marins,159, Viamão, 94490-280, Rio Grande do Sul',
      'R. Salvador Nunes Marins, 159 - Nossa Sra. Aparecida, Viamão - RS, 94490-280, Brazil',
      '-30.0616038',
      '-51.1133506',
      'Rua Salvador Nunes Marins',
      '159',
      'Nossa Senhora Aparecida',
      'Viamão',
      'Rio Grande do Sul',
      '94490-280',
    ],
    [
      108,
      'Riachuelo, 3261, Rosário do Sul, 97590-000, Rio Grande do Sul',
      'R. Riachuelo, 3261 - Centro, Rosário do Sul - RS, 97590-000, Brazil',
      '-30.2533247',
      '-54.9205943',
      'Rua Riachuelo',
      '3261',
      'Centro',
      'Rosário do Sul',
      'Rio Grande do Sul',
      '97590-000',
    ],
    [
      109,
      'Cel. Scherer, 304, Santa Maria, 97020-170, Rio Grande do Sul',
      "R. Cel. Scherer, 304 - Passo D'areia, Santa Maria - RS, 97020-170, Brazil",
      '-29.6824252',
      '-53.8382565',
      'Rua Coronel Scherer',
      '304',
      "Passo D'areia",
      'Santa Maria',
      'Rio Grande do Sul',
      '97020-170',
    ],
    [
      110,
      'Jose Gomercindo da Rosa,32, Passo Fundo, 99025-105, Rio Grande do Sul',
      'R. José Gomercindo da Rosa, 32 - Boqueirão, Passo Fundo - RS, 99025-105, Brazil',
      '-28.2644849',
      '-52.4274619',
      'Rua José Gomercindo da Rosa',
      '32',
      'Boqueirão',
      'Passo Fundo',
      'Rio Grande do Sul',
      '99025-105',
    ],
    [
      111,
      'Vila Manchinha, Três de Maio, 98910-000, Rio Grande do Sul',
      'Manchinha, Três de Maio - RS, 98910-000, Brazil',
      '-27.6906821',
      '-54.22537269999999',
      '',
      '',
      '',
      'Três de Maio',
      'Rio Grande do Sul',
      '98910-000',
    ],
    [
      112,
      'Passo do Antonio Maria 5° Distrito, Canguçú, 96600-000, Rio Grande do Sul',
      'Canguçu - RS, 96600-000, Brazil',
      '-31.2634559',
      '-52.6172766',
      '',
      '',
      '',
      'Canguçu',
      'Rio Grande do Sul',
      '96600-000',
    ],
    [
      113,
      'rua Manoel de Nobrega, 619, Independência, 98915-000, Rio Grande do Sul',
      'R. Padre Manoel da Nóbrega, Santo Ângelo - RS, Brazil',
      '-28.282418',
      '-54.2625233',
      'Rua Padre Manoel da Nóbrega',
      '',
      '',
      'Santo Ângelo',
      'Rio Grande do Sul',
      '',
    ],
    [
      114,
      'Rua São Geraldo, 567, Bairro Ermo, Guaíba, Rio Grande do Sul',
      'R. São Geraldo, 567 - Ermo, Guaíba - RS, 92500-000, Brazil',
      '-30.1234261',
      '-51.3169635',
      'Rua São Geraldo',
      '567',
      'Ermo',
      'Guaíba',
      'Rio Grande do Sul',
      '92500-000',
    ],
    [
      115,
      'Estância Velha, Rio Grande do Sul',
      'Estância Velha, RS, 93600-000, Brazil',
      '-29.6540396',
      '-51.1848488',
      '',
      '',
      '',
      'Estância Velha',
      'Rio Grande do Sul',
      '93600-000',
    ],
    [
      116,
      'Rua Leodoro Pereira da Silva, 657, Vila dos Sargentos, Porto Alegre, Rio Grande do Sul',
      'R. Leodoro Pereira da Silva, 657 - Serraria, Porto Alegre - RS, 91770-270, Brazil',
      '-30.162987',
      '-51.2308303',
      'Rua Leodoro Pereira da Silva',
      '657',
      'Serraria',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91770-270',
    ],
    [
      117,
      'Quadra Vinte e Um, n°7, Bairro Tabajara Brites, Uruguaiana, Rio Grande do Sul',
      'Tabajara Brites, Uruguaiana - RS, Brazil',
      '-29.7820536',
      '-57.1055466',
      '',
      '',
      'Tabajara Brites',
      'Uruguaiana',
      'Rio Grande do Sul',
      '',
    ],
    [
      118,
      'Rua Músico Nelson Ferreira, 230, Cel. Aparício Borges, Porto Alegre, Rio Grande do Sul',
      'R. Músico Nelson Ferreira, 230 - Cel. Aparicio Borges, Porto Alegre - RS, 91710-131, Brazil',
      '-30.0748914',
      '-51.184408',
      'Rua Músico Nelson Ferreira',
      '230',
      'Coronel Aparicio Borges',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91710-131',
    ],
    [
      119,
      'Campo Novo, Rio Grande do Sul',
      'Campo Novo - RS, Brazil',
      '-27.6765124',
      '-53.80178830000001',
      '',
      '',
      '',
      'Campo Novo',
      'Rio Grande do Sul',
      '',
    ],
    [
      120,
      'Rua Linha Carreirão s/n, Interior, Palmitinho, Rio Grande do Sul',
      'Palmitinho, RS, 98430-000, Brazil',
      '-27.3600576',
      '-53.5585464',
      '',
      '',
      '',
      'Palmitinho',
      'Rio Grande do Sul',
      '98430-000',
    ],
    [
      121,
      'Rua São Lucas, 516, Jd. Aparecida, Alvorada, Rio Grande do Sul',
      'R. São Lucas, 516 - Aparecida, Alvorada - RS, Brazil',
      '-30.0324193',
      '-51.0579895',
      'Rua São Lucas',
      '516',
      'Aparecida',
      'Alvorada',
      'Rio Grande do Sul',
      '',
    ],
    [
      122,
      'Av. Manoel Antonio Peres, 2873, Bairro Areal, Pelotas, Rio Grande do sul',
      'Av. Manoel Antônio Peres, 2873 - Areal, Pelotas - RS, 96081-300, Brazil',
      '-31.737399',
      '-52.31665460000001',
      'Avenida Manoel Antônio Peres',
      '2873',
      'Areal',
      'Pelotas',
      'Rio Grande do Sul',
      '96081-300',
    ],
    [
      123,
      'Rua Felisberto de Andrade, 437, Bairro Beira-Rio, Charqueadas, Rio Grande do sul',
      'R. Felisberto Andrade, 437 - Vila Rosa, Charqueadas - RS, 96745-000, Brazil',
      '-29.9527012',
      '-51.6285417',
      'Rua Felisberto Andrade',
      '437',
      'Vila Rosa',
      'Charqueadas',
      'Rio Grande do Sul',
      '96745-000',
    ],
    [
      124,
      'Area São Roque, 1111, Interior, Boqueirão do Leão, Rio Grande do Sul',
      'Boqueirão do Leão, RS, 95920-000, Brazil',
      '-29.3049992',
      '-52.43217019999999',
      '',
      '',
      '',
      'Boqueirão do Leão',
      'Rio Grande do Sul',
      '95920-000',
    ],
    [
      125,
      'Entre Rios do Sul, Rio Grande do Sul',
      'Entre Rios do Sul, RS, 99645-000, Brazil',
      '-27.5303232',
      '-52.7352199',
      '',
      '',
      '',
      'Entre Rios do Sul',
      'Rio Grande do Sul',
      '99645-000',
    ],
    [
      126,
      'Rua Licio Cavalheiro,n° 5, Bairro Partenon, Porto Alegre, Rio Grande do Sul',
      'R. Lício Cavalheiro, 5 - Partenon, Porto Alegre - RS, 90610-150, Brazil',
      '-30.0598869',
      '-51.1796538',
      'Rua Lício Cavalheiro',
      '5',
      'Partenon',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90610-150',
    ],
    [
      127,
      'Acamp. Agulhas Negras, 173, Porto Alegre, Rio Grande do sul',
      'R. Agulhas Negras, 173 - Cel. Aparicio Borges, Porto Alegre - RS, 91710-080, Brazil',
      '-30.0767783',
      '-51.1895395',
      'Rua Agulhas Negras',
      '173',
      'Coronel Aparicio Borges',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91710-080',
    ],
    [
      128,
      'Rua Moab Caldas, 62, Bairro Santa Tereza, Porto Alegre, Rio Grande do Sul',
      'Av. Moab Caldas, 62 - Santa Tereza, Porto Alegre - RS, 90880-310, Brazil',
      '-30.0685974',
      '-51.2136327',
      'Avenida Moab Caldas',
      '62',
      'Santa Tereza',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90880-310',
    ],
    [
      129,
      'Santa Maria, Rio Grande do Sul',
      'Santa Maria - RS, Brazil',
      '-29.687634',
      '-53.8129003',
      '',
      '',
      '',
      'Santa Maria',
      'Rio Grande do Sul',
      '',
    ],
    [
      130,
      'Rua Martins Rodrigues da Silva, 80, Bairro Novo Horizonte, São Gabriel, Rio Grande do Sul',
      'R. Bento Martins - Centro, São Gabriel - RS, 97300-000, Brazil',
      '-30.3358886',
      '-54.3213145',
      'Rua Bento Martins',
      '',
      'Centro',
      'São Gabriel',
      'Rio Grande do Sul',
      '97300-000',
    ],
    [
      131,
      'Av. Avelino Maciel Neto, 970, Centro, Glorinha, Rio Grande do Sul',
      'Av. Avelino Maciel Neto, 970, Glorinha - RS, 94380-000, Brazil',
      '-29.8896035',
      '-50.7747955',
      'Avenida Avelino Maciel Neto',
      '970',
      '',
      'Glorinha',
      'Rio Grande do Sul',
      '94380-000',
    ],
    [
      132,
      'rua Erva-Mate, 125- bairro Dona Carlota, Santa Cruz, Rio Grande do Sul',
      'Rua Erva-Mate - Distrito Industrial, Santa Cruz do Sul - RS, Brazil',
      '-29.7581139',
      '-52.440893',
      '',
      '',
      'Distrito Industrial',
      'Santa Cruz do Sul',
      'Rio Grande do Sul',
      '',
    ],
    [
      133,
      'Av. Francisco Trein, 837 , Porto Alegre, Rio Grande do Sul',
      'Av. Francisco Trein, 837 - Jardim Ipiranga, Porto Alegre - RS, 91350-200, Brazil',
      '-30.0136061',
      '-51.1598138',
      'Avenida Francisco Trein',
      '837',
      'Jardim Ipiranga',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91350-200',
    ],
    [
      134,
      'Av. João Pessoa, 1165, Bairro Farroupilha, Porto Alegre, Rio Grande do sul',
      'Av. João Pessoa, 1165 - Farroupilha, Porto Alegre - RS, 90040-001, Brazil',
      '-30.0416028',
      '-51.21632049999999',
      'Avenida João Pessoa',
      '1165',
      'Farroupilha',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90040-001',
    ],
    [
      135,
      'Rua dos Maias, 1491, apt302, Bairro Rubem Berta, Porto Alegre, Rio Grande do sul',
      'R. dos Maias, 1491 - 302 - Rubem Berta, Porto Alegre - RS, 91170-200, Brazil',
      '-30.00093609999999',
      '-51.0974586',
      'Rua dos Maias',
      '1491',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91170-200',
    ],
    [
      136,
      'Esquina Beck, 1491, Interior, Condor, Rio Grande do sul',
      'Condor - RS, 98290-000, Brazil',
      '-28.0718449',
      '-53.5428522',
      '',
      '',
      '',
      'Condor',
      'Rio Grande do Sul',
      '98290-000',
    ],
    [
      137,
      'Acesso B, 99, Passo das Pedras, Porto Alegre, Rio Grande do sul',
      'Ac. B, 99 - Passo das Pedras, Porto Alegre - RS, 91220, Brazil',
      '-30.02859429999999',
      '-51.1299856',
      'Acesso B',
      '99',
      'Passo das Pedras',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91220',
    ],
    [
      138,
      'Travessa Beco Rio Grande, 1746, Cedro, Alvorada, Rio Grande do Sul',
      'R. Cedro, 1746 - Maria Regina, Alvorada - RS, 94828-140, Brazil',
      '-29.9839133',
      '-51.06278709999999',
      'Rua Cedro',
      '1746',
      'Maria Regina',
      'Alvorada',
      'Rio Grande do Sul',
      '94828-140',
    ],
    [
      139,
      'Cruzeiro do Sul, Rio Grande do Sul',
      'Cruzeiro do Sul, Rio Grande do Sul, Cruzeiro do Sul - RS, 95930-000, Brazil',
      '-29.5137043',
      '-51.99249',
      '',
      '',
      '',
      'Cruzeiro do Sul',
      'Rio Grande do Sul',
      '95930-000',
    ],
    [
      140,
      'São Leopoldo, Rio Grande do Sul',
      'São Leopoldo, RS, Brazil',
      '-29.7549941',
      '-51.150283',
      '',
      '',
      '',
      'São Leopoldo',
      'Rio Grande do Sul',
      '',
    ],
    [
      141,
      'Rua Hugo Fournier Luz, 246, Fragata, Pelotas, Rio Grande do Sul',
      'R. Hugo Fournier Luz, 246 - Fragata, Pelotas - RS, 96040-100, Brazil',
      '-31.7474816',
      '-52.3702228',
      'Rua Hugo Fournier Luz',
      '246',
      'Fragata',
      'Pelotas',
      'Rio Grande do Sul',
      '96040-100',
    ],
    [
      142,
      'Avenida Um, 271, Fragatra, Pelotas, Rio Grande do Sul',
      'Av. Um, 271 - Fragata, Pelotas - RS, 96045-010, Brazil',
      '-31.7403795',
      '-52.3975076',
      'Avenida Um',
      '271',
      'Fragata',
      'Pelotas',
      'Rio Grande do Sul',
      '96045-010',
    ],
    [
      143,
      'Avenida Getulio Vargas, 815, Santa Albina, Minas do Leão, Rio Grande do Sul',
      'Av. Getúlio Vargas, 815 - Santa Albina, Minas do Leão - RS, 96755-000, Brazil',
      '-30.1409953',
      '-52.0442677',
      'Avenida Getúlio Vargas',
      '815',
      'Santa Albina',
      'Minas do Leão',
      'Rio Grande do Sul',
      '96755-000',
    ],
    [
      144,
      'Rua Sonia Haas, 140, Brand,Venancio Aires, Rio Grande do sul',
      'R. Profa. Sonia Haas, 140 - Brands, Venâncio Aires - RS, 95800-000, Brazil',
      '-29.623395',
      '-52.179129',
      'Rua Professora Sonia Haas',
      '140',
      'Brands',
      'Venâncio Aires',
      'Rio Grande do Sul',
      '95800-000',
    ],
    [
      145,
      'Rua da Comunidade, 595, Lomba do Pinheiro, Porto Alegre, Rio Grande do sul',
      'R. da Comunidade, 595 - Lomba do Pinheiro, Porto Alegre - RS, 91560-550, Brazil',
      '-30.1284168',
      '-51.11041119999999',
      'Rua da Comunidade',
      '595',
      'Lomba do Pinheiro',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91560-550',
    ],
    [
      146,
      'Rua 773.200, Fenix, Bagé, Rio Grande do sul',
      'Bagé - RS, Brazil',
      '-31.3284966',
      '-54.092275',
      '',
      '',
      '',
      'Bagé',
      'Rio Grande do Sul',
      '',
    ],
    [
      147,
      'Porto Alegre, Rio Grande do Sul',
      'Porto Alegre, RS, Brazil',
      '-30.0346471',
      '-51.2176584',
      '',
      '',
      '',
      'Porto Alegre',
      'Rio Grande do Sul',
      '',
    ],
    [
      148,
      'Rua Rafael Athanasio, 144, Centro, São Jerônimo, Rio Grande do Sul',
      'R. Rafael Athanásio Sobrinho, 144 - Cidade Baixa, São Jerônimo - RS, 96700-000, Brazil',
      '-29.9563421',
      '-51.72019359999999',
      'Rua Rafael Athanásio Sobrinho',
      '144',
      'Cidade Baixa',
      'São Jerônimo',
      'Rio Grande do Sul',
      '96700-000',
    ],
    [
      149,
      'Rua Polônia. 395, capão da Cruz, Sapucaia do Sul, Rio Grande do Sul',
      'R. Polônia, 395 - Capão da Cruz, Sapucaia do Sul - RS, 93226-468, Brazil',
      '-29.8392168',
      '-51.1517201',
      'Rua Polônia',
      '395',
      'Capão da Cruz',
      'Sapucaia do Sul',
      'Rio Grande do Sul',
      '93226-468',
    ],
    [
      150,
      'Rua Ernesto Alves, 407, Miguel de Castro Moreira, Rio Grande, Rio Grande do Sul',
      'R. Ernesto Alves, 407 - Miguel de Castro Moreira, Rio Grande - RS, 96211-650, Brazil',
      '-32.0430745',
      '-52.1213737',
      'Rua Ernesto Alves',
      '407',
      'Miguel de Castro Moreira',
      'Rio Grande',
      'Rio Grande do Sul',
      '96211-650',
    ],
    [
      151,
      'Porto Alegre, Rio Grande do Sul',
      'Porto Alegre, RS, Brazil',
      '-30.0346471',
      '-51.2176584',
      '',
      '',
      '',
      'Porto Alegre',
      'Rio Grande do Sul',
      '',
    ],
    [
      152,
      'Condomínio Por do Sol, 18, Humaitá, Porto Alegre, Rio Grande do Sul',
      'Av. José Aloísio Filho, 595 - Humaitá, Porto Alegre - RS, 90250-180, Brazil',
      '-29.9830566',
      '-51.1863355',
      'Avenida José Aloísio Filho',
      '595',
      'Humaitá',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90250-180',
    ],
    [
      153,
      'Rua Hildo Meneguete, 547, Estalagem, Viamão, Rio Grande do sul',
      'R. Eng. Ildo Meneghetti, 547 - Estalagem, Viamão - RS, 94425-010, Brazil',
      '-30.0806754',
      '-51.0008063',
      'Rua Engenheiro Ildo Meneghetti',
      '547',
      'Estalagem',
      'Viamão',
      'Rio Grande do Sul',
      '94425-010',
    ],
    [
      154,
      'Rua Monsenhor Ruben Neis, n°7, Cavalhada, Porto Alegre, Rio Grande do sul',
      'R. Monsenhor Ruben Neis, 7 - Cavalhada, Porto Alegre - RS, 91920-243, Brazil',
      '-30.1167905',
      '-51.2247969',
      'Rua Monsenhor Ruben Neis',
      '7',
      'Cavalhada',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91920-243',
    ],
    [
      155,
      'Rua Arquibaldo de Oliveira. 195, Cel Maria Terra, Tupanciretâ, Rio Grande do sul',
      'Av. Vaz Ferreira, 1755 - Centro, Tupanciretã - RS, 98170-000, Brazil',
      '-29.076352',
      '-53.83894369999999',
      'Avenida Vaz Ferreira',
      '1755',
      'Centro',
      'Tupanciretã',
      'Rio Grande do Sul',
      '98170-000',
    ],
    [
      156,
      'Area Bento Gonçalves, Ponpéia,Vista Alegre do Prata, Rio Grande do Sul',
      'Bento Gonçalves, Rio Grande do Sul, Bento Gonçalves - RS, 95700-000, Brazil',
      '-29.1667089',
      '-51.5169861',
      '',
      '',
      '',
      'Bento Gonçalves',
      'Rio Grande do Sul',
      '95700-000',
    ],
    [
      157,
      'Rua Loureiro da Silva, 1037, Piratini, Alvorada, Rio Grande do Sul',
      'R. Loureiro da Silva, 1037 - Piratini, Alvorada - RS, 94838-370, Brazil',
      '-30.0276639',
      '-51.0511093',
      'Rua Loureiro da Silva',
      '1037',
      'Piratini',
      'Alvorada',
      'Rio Grande do Sul',
      '94838-370',
    ],
    [
      158,
      'Rua Seberi, 60, Marmitt, Estrela, Rio Grande do sul',
      'R. Seberi, 60 - Oriental, Estrela - RS, 95880-000, Brazil',
      '-29.4886595',
      '-51.9732508',
      'Rua Seberi',
      '60',
      'Oriental',
      'Estrela',
      'Rio Grande do Sul',
      '95880-000',
    ],
    [
      159,
      'rua Gomes Carneiro, 2464, Centro, Pelotas, 96010-000, Rio Grande do Sul',
      'R. Gomes Carneiro, 2464 - Centro, Pelotas - RS, 96010-610, Brazil',
      '-31.7761074',
      '-52.3414904',
      'Rua Gomes Carneiro',
      '2464',
      'Centro',
      'Pelotas',
      'Rio Grande do Sul',
      '96010-610',
    ],
    [
      160,
      'Av Vila Santissima Trindade, 477, Rubem Berta, Porto Alegre, 91160-800',
      'Av. Vila Santíssima Trindade, 477 - Rubem Berta, Porto Alegre - RS, 91160-000, Brazil',
      '-29.9998728',
      '-51.1080205',
      'Avenida Vila Santíssima Trindade',
      '477',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91160-000',
    ],
    [
      161,
      'r. Vista Alegre, 138, vila Umbu, Alvorada, Rio Grande do Sul',
      'R. Vista Alegre, 138 - Umbu, Alvorada - RS, 94834-228, Brazil',
      '-29.996648',
      '-51.043427',
      'Rua Vista Alegre',
      '138',
      'Umbu',
      'Alvorada',
      'Rio Grande do Sul',
      '94834-228',
    ],
    [
      162,
      'Quilombo Viamão, Rio Grande do sul',
      'Estr. Estância Grande, Viamão - RS, Brazil',
      '-30.0078858',
      '-50.9217779',
      'Estrada Estância Grande',
      '',
      '',
      'Viamão',
      'Rio Grande do Sul',
      '',
    ],
    [
      163,
      'r. Safira 556 - Hidráulica - Rio Grande, Rio Grande do sul',
      'Travessa Safíra, 556 - Vila Hidraulica, Rio Grande - RS, 96211-316, Brazil',
      '-32.0476813',
      '-52.124659',
      'Travessa Safíra',
      '556',
      'Vila Hidraulica',
      'Rio Grande',
      'Rio Grande do Sul',
      '96211-316',
    ],
    [
      164,
      'r. Dois de Novembro,09 - Patronato Santa Maria, Rio Grande do sul',
      'Av. Dois de Novembro, 9 - Patronato, Santa Maria - RS, 97020-230, Brazil',
      '-29.692942',
      '-53.8204301',
      'Avenida Dois de Novembro',
      '9',
      'Patronato',
      'Santa Maria',
      'Rio Grande do Sul',
      '97020-230',
    ],
    [
      165,
      'r. Cel. Pedroso, 326 Buch Hoez - Rio Grande, Rio Grande do Sul',
      'R. Cel. Pedroso, 326 - Vila Rural, Rio Grande - RS, 96212-120, Brazil',
      '-32.04743990000001',
      '-52.1360607',
      'Rua Coronel Pedroso',
      '326',
      'Vila Rural',
      'Rio Grande',
      'Rio Grande do Sul',
      '96212-120',
    ],
    [
      166,
      'Pique II, Pontão, Rio Grande do Sul',
      'Pontão, RS, 99190-000, Brazil',
      '-28.0589672',
      '-52.679605',
      '',
      '',
      '',
      'Pontão',
      'Rio Grande do Sul',
      '99190-000',
    ],
    [
      167,
      'Mariano Moro, Rio Grande do sul',
      'Mariano Moro, RS, 99790-000, Brazil',
      '-27.3572419',
      '-52.1471676',
      '',
      '',
      '',
      'Mariano Moro',
      'Rio Grande do Sul',
      '99790-000',
    ],
    [
      168,
      'r. Sotero dos Reis, 261 - Passo das Pedras, Porto Alegre, Rio Grande do sul',
      'R. Sotero dos Reis, 261 - Passo das Pedras, Porto Alegre - RS, 91230-450, Brazil',
      '-30.014727',
      '-51.125426',
      'Rua Sotero dos Reis',
      '261',
      'Passo das Pedras',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91230-450',
    ],
    [
      169,
      'r. 2048, n°149 Mário Quintana, Porto Alegre, Rio Grande do sul',
      'R. Mario Quintana, 149 - 2048 - Sarandi, Porto Alegre - RS, 91140-260, Brazil',
      '-29.9878617',
      '-51.1135487',
      'Rua Mario Quintana',
      '149',
      'Sarandi',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91140-260',
    ],
    [
      170,
      'r. Rodrigo Alves, 516, Niterói - Canoas, Rio Grande do Sul',
      'R. Rodrigues Alves, 516 - Niterói, Canoas - RS, 92130-430, Brazil',
      '-29.9601455',
      '-51.1706916',
      'Rua Rodrigues Alves',
      '516',
      'Niterói',
      'Canoas',
      'Rio Grande do Sul',
      '92130-430',
    ],
    [
      171,
      'Potreiro Grande - Canguçu, Rio Grande do Sul',
      'Potreiro Grande, Formigueiro - RS, 97210-000, Brazil',
      '-29.9814797',
      '-53.4456216',
      '',
      '',
      '',
      'Formigueiro',
      'Rio Grande do Sul',
      '97210-000',
    ],
    [
      172,
      'r. Major Frazão, 294, Centro, Livramento, Rio Grande do Sul',
      'Centro, Santana do Livramento - RS, Brazil',
      '-30.8909655',
      '-55.5330434',
      '',
      '',
      'Centro',
      'Santana do Livramento',
      'Rio Grande do Sul',
      '',
    ],
    [
      173,
      'Picada da Rosa - Fontoura Xavier, Rio Grande do Sul',
      'Est Picada Rosa, s/n Picada Rosa, Fontoura Xavier - RS, 99370-000, Brazil',
      '-28.979471',
      '-52.343193',
      '',
      '',
      '',
      'Fontoura Xavier',
      'Rio Grande do Sul',
      '99370-000',
    ],
    [
      174,
      'Estrada Martim Félix Berta, Porto Alegre, Rio Grande do Sul',
      'Estr. Martim Félix Berta, Porto Alegre - RS, Brazil',
      '-30.0268672',
      '-51.1079658',
      'Estrada Martim Félix Berta',
      '',
      '',
      'Porto Alegre',
      'Rio Grande do Sul',
      '',
    ],
    [
      175,
      'r. Da Mata, 353- Algarve - Alvorada, Rio Grande do sul',
      'R. da Mata, 353 - Aparecida, Alvorada - RS, 94853-835, Brazil',
      '-30.0286052',
      '-51.0676849',
      'Rua da Mata',
      '353',
      'Aparecida',
      'Alvorada',
      'Rio Grande do Sul',
      '94853-835',
    ],
    [
      176,
      'r. São Geraldo, 84 Bairro Ermo  - Guaíba, Rio Grande do sul',
      'R. São Geraldo - Ermo, Guaíba - RS, 92500-000, Brazil',
      '-30.1274914',
      '-51.319178',
      'Rua São Geraldo',
      '',
      'Ermo',
      'Guaíba',
      'Rio Grande do Sul',
      '92500-000',
    ],
    [
      177,
      'r. Ernesto Moreh, 54 - Santa Marta, Passo Fundo, Rio Grande do Sul',
      'Santa Marta, Passo Fundo - RS, Brazil',
      '-28.2889827',
      '-52.43422349999999',
      '',
      '',
      'Santa Marta',
      'Passo Fundo',
      'Rio Grande do Sul',
      '',
    ],
    [
      178,
      'r. Joaquim Vieira da Cunha, 353 - Areal, Pelotas, Rio Grande do sul',
      'R. Joaquim Viêira da Cunha, 353 - Areal, Pelotas - RS, 96077-140, Brazil',
      '-31.7531188',
      '-52.30479',
      'Rua Joaquim Viêira da Cunha',
      '353',
      'Areal',
      'Pelotas',
      'Rio Grande do Sul',
      '96077-140',
    ],
    [
      179,
      'r. Arno Jaeger, 139 - bairro Pavão Barra do Ribeiro, Rio Grande do sul',
      'R. Arnô Jaeger, 139 - Pavão, Barra do Ribeiro - RS, 96790-000, Brazil',
      '-30.3074141',
      '-51.3210302',
      'Rua Arnô Jaeger',
      '139',
      'Pavão',
      'Barra do Ribeiro',
      'Rio Grande do Sul',
      '96790-000',
    ],
    [
      180,
      'r. Bezerra de Menezes, 857 PyCresco - Pelotas, Rio Grande do sul',
      'R. Dr. Bezerra de Menezes, 857 - Tres Vendas, Pelotas - RS, 96065-270, Brazil',
      '-31.7162865',
      '-52.3505615',
      'Rua Doutor Bezerra de Menezes',
      '857',
      'Tres Vendas',
      'Pelotas',
      'Rio Grande do Sul',
      '96065-270',
    ],
    [
      181,
      'Av. Bento Gonçalves, 2889 - São João - Uruguaiana, Rio Grande do Sul',
      'R. Gen. Bento Gonçalves, 2889 - Centro, Uruguaiana - RS, 97500-270, Brazil',
      '-29.7657336',
      '-57.07326949999999',
      'Rua General Bento Gonçalves',
      '2889',
      'Centro',
      'Uruguaiana',
      'Rio Grande do Sul',
      '97500-270',
    ],
    [
      182,
      'r. Nilson S. Costa, 395 Safira - Porto Alegre, Rio Grande do Sul',
      'R. Nilson dos Santos Costa, 395 - Alto Petrópolis, Porto Alegre - RS, 91260-550, Brazil',
      '-30.0384445',
      '-51.10803840000001',
      'Rua Nilson dos Santos Costa',
      '395',
      'Alto Petrópolis',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91260-550',
    ],
    [
      183,
      'r. Figueiras, 172 - Rio Grandino - Pantano Grande, Rio Grande do Sul',
      'R. Getúlio Vargas, 172 - Centro, Pantano Grande - RS, 96690-000, Brazil',
      '-30.1906326',
      '-52.3701301',
      'Rua Getúlio Vargas',
      '172',
      'Centro',
      'Pantano Grande',
      'Rio Grande do Sul',
      '96690-000',
    ],
    [
      184,
      'r. Parai, 19 Partenon - Porto Alegre, 91510-274, Rio Grande do Sul',
      'R. Paraí, 19 - Cel. Aparicio Borges, Porto Alegre - RS, 91510-274, Brazil',
      '-30.0746603',
      '-51.18017769999999',
      'Rua Paraí',
      '19',
      'Coronel Aparicio Borges',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91510-274',
    ],
    [
      185,
      'r. Califórnia, 63, bairro Santa Várbara, alvorada, Rio Grande do Sul',
      'R. Califórnia, 63 - Aparecida, Alvorada - RS, 94853, Brazil',
      '-30.0250033',
      '-51.0609039',
      'Rua Califórnia',
      '63',
      'Aparecida',
      'Alvorada',
      'Rio Grande do Sul',
      '94853',
    ],
    [
      186,
      'r. Beco dos Soares, 3385B, bairro São Lucas - Viamão, Rio Grande do Sul',
      'Rua Beco dos Soares, 3385 - Vila Augusta, Viamão - RS, 94740, Brazil',
      '-30.065691',
      '-51.0764769',
      'Rua Beco dos Soares',
      '3385',
      'Vila Augusta',
      'Viamão',
      'Rio Grande do Sul',
      '94740',
    ],
    [
      187,
      'Loteamento D. Laura, 610 Áreas Verdes - Uruguaiana, Rio Grande do Sul',
      'Tiradentes nr.2361 - Centro, Uruguaiana - RS, 97500-163, Brazil',
      '-29.7540528',
      '-57.09011640000001',
      '',
      '',
      'Centro',
      'Uruguaiana',
      'Rio Grande do Sul',
      '97500-163',
    ],
    [
      188,
      'r. Boa Ventura Leite, 361 - Pelotas, Rio Grande do Sul',
      'R. Dr. Boaventura Leite, 361 - Areal, Pelotas - RS, 96080-480, Brazil',
      '-31.750271',
      '-52.31220099999999',
      'Rua Doutor Boaventura Leite',
      '361',
      'Areal',
      'Pelotas',
      'Rio Grande do Sul',
      '96080-480',
    ],
    [
      189,
      'r. Alves Noqueira, 97 Morada do Vale 3 - Gravataí, Rio Grande do sul',
      'R. Alves Nogueira, 97 - Morada do Vale III, Gravataí - RS, 94080-160, Brazil',
      '-29.9281134',
      '-51.0666889',
      'Rua Alves Nogueira',
      '97',
      'Morada do Vale III',
      'Gravataí',
      'Rio Grande do Sul',
      '94080-160',
    ],
    [
      190,
      'r. Albion, 811 - P.Feijó - Alvorada, Rio Grande do Sul',
      'R. Albion, 811 - Passo do Feijó, Alvorada - RS, 94810-041, Brazil',
      '-30.0072714',
      '-51.085297',
      'Rua Albion',
      '811',
      'Passo do Feijó',
      'Alvorada',
      'Rio Grande do Sul',
      '94810-041',
    ],
    [
      191,
      'r. Dique, 150 - Bairro São João - Porto Alegre, Rio Grande do sul',
      'Av. Dique, 150 - São João, Porto Alegre - RS, 90200-260, Brazil',
      '-29.99367609999999',
      '-51.1547682',
      'Avenida Dique',
      '150',
      'São João',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90200-260',
    ],
    [
      192,
      'r. E, 60 Castelo Branco II - Rio Grande, Rio Grande do Sul',
      'R. e, 60 - Profilurbi, Rio Grande - RS, 96214-060, Brazil',
      '-32.0728365',
      '-52.1792104',
      'Rua e',
      '60',
      'Profilurbi',
      'Rio Grande',
      'Rio Grande do Sul',
      '96214-060',
    ],
    [
      193,
      'rua Quatro de Outubro, 385, Passo das Pedras, Porto Alegre, 91230-492, Rio Grande do Sul',
      'R. 4 de Outubro - Passo das Pedras, Porto Alegre - RS, 91230-492, Brazil',
      '-30.0237782',
      '-51.12343509999999',
      'Rua 4 de Outubro',
      '',
      'Passo das Pedras',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91230-492',
    ],
    [
      194,
      'r. correa Lima, 98 - Menino Deus, Porto Alegre, Rio Grande do Sul',
      'R. Corrêa Lima, 98, Porto Alegre - RS, 90450-190, Brazil',
      '-30.0616628',
      '-51.2202492',
      'Rua Corrêa Lima',
      '98',
      '',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90450-190',
    ],
    [
      195,
      'Av. Beira Mar, 47 Umbu - Alvorada, Rio Grande do sul',
      'Av. Beira Mar, 47 - Umbu, Alvorada - RS, 94828, Brazil',
      '-29.9867956',
      '-51.0523402',
      'Avenida Beira Mar',
      '47',
      'Umbu',
      'Alvorada',
      'Rio Grande do Sul',
      '94828',
    ],
    [
      196,
      'r. Imbu, 35 - Bela Vista - Montenegro, Rio Grande do sul',
      'R. Umbú, 35 - Bela Vista, Montenegro - RS, 95780-000, Brazil',
      '-29.6932522',
      '-51.469463',
      'Rua Umbú',
      '35',
      'Bela Vista',
      'Montenegro',
      'Rio Grande do Sul',
      '95780-000',
    ],
    [
      197,
      'r. Inhatiun, 38 - Mariana - São Gabriel, Rio Grande do Sul',
      '97300-000, São Gabriel - RS, 97300-000, Brazil',
      '-30.2476849',
      '-54.5813622',
      '',
      '',
      '',
      'São Gabriel',
      'Rio Grande do Sul',
      '97300-000',
    ],
    [
      198,
      'Av. Oscar Pereira, 6022 - Cascata - Porto Alegre, Rio Grande do sul',
      'Av. Oscar Pereira, 6022 - Cascata, Porto Alegre - RS, 91712-320, Brazil',
      '-30.0933096',
      '-51.1792189',
      'Avenida Oscar Pereira',
      '6022',
      'Cascata',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91712-320',
    ],
    [
      199,
      'rua Alameda, 362, bairro primavera, Capela de Santana, 95745-000, Rio Grande do Sul',
      'Capela de Santana - RS, 95745-000, Brazil',
      '-29.7168644',
      '-51.3679914',
      '',
      '',
      '',
      'Capela de Santana',
      'Rio Grande do Sul',
      '95745-000',
    ],
    [
      200,
      'Picada Rosa - Fontoura Xavier, Rio Grande do sul',
      'Fontoura Xavier - RS, 99370-000, Brazil',
      '-29.0393623',
      '-52.4348239',
      '',
      '',
      '',
      'Fontoura Xavier',
      'Rio Grande do Sul',
      '99370-000',
    ],
    [
      201,
      'r. Avelino dos Santos, 43 Bairro Bom Jesus Santa Cruz do Sul, Rio Grande do sul',
      'R. Nestor Bunecker, 43 - Linha Travessa-Aeroporto, Santa Cruz do Sul - RS, 96821-250, Brazil',
      '-29.6866964',
      '-52.4077074',
      'Rua Nestor Bunecker',
      '43',
      'Linha Travessa-Aeroporto',
      'Santa Cruz do Sul',
      'Rio Grande do Sul',
      '96821-250',
    ],
    [
      202,
      'r. Arthur Mello Gutierres , 220 Livramento, Rio Grande do sul',
      'R. Arthur Mello Gutierrez, 220 - Tabatinga, Santana do Livramento - RS, 97578-130, Brazil',
      '-30.8680564',
      '-55.4860313',
      'Rua Arthur Mello Gutierrez',
      '220',
      'Tabatinga',
      'Santana do Livramento',
      'Rio Grande do Sul',
      '97578-130',
    ],
    [
      203,
      'r. Marechal Hermes,799 Cachoeira do Sul, Rio Grande do sul',
      'R. Mal. Hermes, 799 - Goncalves, Cachoeira do Sul - RS, 96503-481, Brazil',
      '-30.0289806',
      '-52.91235409999999',
      'Rua Marechal Hermes',
      '799',
      'Goncalves',
      'Cachoeira do Sul',
      'Rio Grande do Sul',
      '96503-481',
    ],
    [
      204,
      'r, Alecrim,812 Rincão dos Ilhéus - Estância Velha, Rio Grande do sul',
      'R. Alecrim - Rincão dos Ilhéus, Estância Velha - RS, 93600-000, Brazil',
      '-29.6687188',
      '-51.1550404',
      'Rua Alecrim',
      '',
      'Rincão dos Ilhéus',
      'Estância Velha',
      'Rio Grande do Sul',
      '93600-000',
    ],
    [
      205,
      'r,Sem Teotônio vilela,115, Jardim Cascata - Porto Alegre, Rio Grande do sul',
      'R. Sen. Teotônio Viléla, 115 - Cascata, Porto Alegre - RS, 91710-460, Brazil',
      '-30.081494',
      '-51.1922045',
      'Rua Senador Teotônio Viléla',
      '115',
      'Cascata',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91710-460',
    ],
    [
      206,
      'r. Souza Lobo, 695 - Vila Jardim - Porto Alegre, Rio Grande do sul',
      'R. Souza Lôbo, 695 - Vila Jardim, Porto Alegre - RS, 91320-320, Brazil',
      '-30.037645',
      '-51.1527315',
      'Rua Souza Lôbo',
      '695',
      'Vila Jardim',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91320-320',
    ],
    [
      207,
      'Quadra 28 casa 427 - Promorar - Caçapava do Sul, Rio Grande do sul',
      'Caçapava do Sul, RS, 96570-000, Brazil',
      '-30.5148445',
      '-53.4832383',
      '',
      '',
      '',
      'Caçapava do Sul',
      'Rio Grande do Sul',
      '96570-000',
    ],
    [
      208,
      'r. Mulan Gucener,1436 - Santa Cecília - Bagé, Rio Grande do sul',
      'Bagé, RS, Brazil',
      '-31.3301424',
      '-54.1004622',
      '',
      '',
      '',
      'Bagé',
      'Rio Grande do Sul',
      '',
    ],
    [
      209,
      'r. Ernesto Pereira, 660 - Lídias - Júlio de Castilhos , Rio Grande do sul',
      'R. Ernesto Pereira, 660, Júlio de Castilhos - RS, 98130-000, Brazil',
      '-29.2398956',
      '-53.6957288',
      'Rua Ernesto Pereira',
      '660',
      '',
      'Júlio de Castilhos',
      'Rio Grande do Sul',
      '98130-000',
    ],
    [
      210,
      'r. Charrua, 08 - Parque ìndio Jari - Viamão, Rio Grande do sul',
      'R. Charruas, 8 - Parque Indio Jari, Viamão - RS, 94495-000, Brazil',
      '-30.0516964',
      '-51.0968222',
      'Rua Charruas',
      '8',
      'Parque Indio Jari',
      'Viamão',
      'Rio Grande do Sul',
      '94495-000',
    ],
    [
      211,
      'r. Boaventura Ferreira da Silva, 298 - Camita - São Gabriel, Rio Grande do sul',
      'R. Boaventura da Silva, 298 - Vila Camita, São Gabriel - RS, 97300-000, Brazil',
      '-30.3471532',
      '-54.3260055',
      'Rua Boaventura da Silva',
      '298',
      'Vila Camita',
      'São Gabriel',
      'Rio Grande do Sul',
      '97300-000',
    ],
    [
      212,
      'Travessa Ieda,55 - Santa Tereza - Porto Alegre, Rio Grande do sul',
      'Tv. Iêda, 55 - Santa Tereza, Porto Alegre - RS, 90880-230, Brazil',
      '-30.065641',
      '-51.216558',
      'Travessa Iêda',
      '55',
      'Santa Tereza',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90880-230',
    ],
    [
      213,
      'r. Pioneiro,724 - UMBU - Alvorada, Rio Grande do sul',
      'R. Pioneiro, 724 - Umbu, Alvorada - RS, 94834-680, Brazil',
      '-29.9919366',
      '-51.0465934',
      'Rua Pioneiro',
      '724',
      'Umbu',
      'Alvorada',
      'Rio Grande do Sul',
      '94834-680',
    ],
    [
      214,
      'Salgado Filho, 715 - Centro - Bagé, Rio Grande do sul',
      'R. Sen. Salgado Filho, 715 - Floresta, Bagé - RS, 96400-600, Brazil',
      '-31.334109',
      '-54.11499860000001',
      'Rua Senador Salgado Filho',
      '715',
      'Floresta',
      'Bagé',
      'Rio Grande do Sul',
      '96400-600',
    ],
    [
      215,
      'r. Mariano do Canto, 822 - jardim - Sapucaia do Sul, Rio Grande do sul',
      'R. Mariano Canto, 822 - Jardim, Sapucaia do Sul - RS, 93222-110, Brazil',
      '-29.8255063',
      '-51.1391161',
      'Rua Mariano Canto',
      '822',
      'Jardim',
      'Sapucaia do Sul',
      'Rio Grande do Sul',
      '93222-110',
    ],
    [
      216,
      'r. Ricardo Ricannon, 410 - São João - Rio Grande, Rio Grande do sul',
      'Vila Sao Joao, Rio Grande - RS, Brazil',
      '-32.0599236',
      '-52.16601600000001',
      '',
      '',
      'Vila Sao Joao',
      'Rio Grande',
      'Rio Grande do Sul',
      '',
    ],
    [
      217,
      'r. Geraldo Winck, 340 - Garcia - Arroio dos Ratos, Rio Grande do sul',
      'Estr. Geraldo Winck, 340, Arroio dos Ratos - RS, 96740-000, Brazil',
      '-30.0378104',
      '-51.7082875',
      'Estrada Geraldo Winck',
      '340',
      '',
      'Arroio dos Ratos',
      'Rio Grande do Sul',
      '96740-000',
    ],
    [
      218,
      'Av. Um, 1432 - Dunas - Pelotas, Rio Grande do sul',
      'Av. Um, 1432 - Dunas, Pelotas - RS, 96081-115, Brazil',
      '-31.7382571',
      '-52.31897319999999',
      'Avenida Um',
      '1432',
      'Dunas',
      'Pelotas',
      'Rio Grande do Sul',
      '96081-115',
    ],
    [
      219,
      'r. João Freitas Ferreira, 58 Tabatinga - Livramento, Rio Grande do sul',
      'R. João Freitas Ferreira, 58 - Tabatinga, Santana do Livramento - RS, 97578-080, Brazil',
      '-30.87305049999999',
      '-55.48015419999999',
      'Rua João Freitas Ferreira',
      '58',
      'Tabatinga',
      'Santana do Livramento',
      'Rio Grande do Sul',
      '97578-080',
    ],
    [
      220,
      'r. F.36 Bom Jesus Porto Alegre, Rio Grande do sul',
      'R. F, 36 - Bom Jesus, Porto Alegre - RS, 91420-691, Brazil',
      '-30.0478031',
      '-51.159319',
      'Rua F',
      '36',
      'Bom Jesus',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91420-691',
    ],
    [
      221,
      'r. Quatro de Outubro, 87 - Passo das Pedras - Porto Alegre, Rio Grande do sul',
      'R. 4 de Outubro, 87 - Passo das Pedras, Porto Alegre - RS, 91230-492, Brazil',
      '-30.0238803',
      '-51.1235629',
      'Rua 4 de Outubro',
      '87',
      'Passo das Pedras',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91230-492',
    ],
    [
      222,
      'rua seis, 803 -  Guarida - São José do Norte, Rio Grande do Sul',
      'Guarida, São José do Norte - RS, 96225-000, Brazil',
      '-32.0148238',
      '-52.03544549999999',
      '',
      '',
      'Guarida',
      'São José do Norte',
      'Rio Grande do Sul',
      '96225-000',
    ],
    [
      223,
      'Rua Presidente Getulio Vargas nº 4.900 Bairro Maria Regina – Alvorada, Rio Grande do Sul',
      'Av. Pres. Getúlio Vargas, 4, Alvorada - RS, 94810-041, Brazil',
      '-30.0112777',
      '-51.0925944',
      'Avenida Presidente Getúlio Vargas',
      '4',
      '',
      'Alvorada',
      'Rio Grande do Sul',
      '94810-041',
    ],
    [
      224,
      'Vila Segredo – Ipê, Rio Grande do Sul',
      'Vila Segredo, Ipê - RS, 95240-000, Brazil',
      '-28.7615679',
      '-51.378038',
      '',
      '',
      '',
      'Ipê',
      'Rio Grande do Sul',
      '95240-000',
    ],
    [
      225,
      'Rua Millo Raffin, nº 25 – casa / Mario Quintana – Porto Alegre, Rio Grande do Sul',
      'Rua Millo Raffin, 25 - Jardim Leopoldina, Porto Alegre - RS, 91240-475, Brazil',
      '-30.0298847',
      '-51.11683180000001',
      'Rua Millo Raffin',
      '25',
      'Jardim Leopoldina',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91240-475',
    ],
    [
      226,
      'Rua Parai, nº 19 / Partenon – Porto Alegre, Rio Grande do Sul',
      'Estr. da Praia, 19 - Ponta Grossa, Porto Alegre - RS, 91778, Brazil',
      '-30.1893963',
      '-51.204986',
      'Estrada da Praia',
      '19',
      'Ponta Grossa',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91778',
    ],
    [
      227,
      'Rua Lima e Silva, 234/404,  Porto Alegre, Rio Grande do Sul',
      'R. Gen. Lima e Silva, 234 - Centro Histórico, Porto Alegre - RS, 90050-100, Brazil',
      '-30.0359085',
      '-51.2241407',
      'Rua General Lima e Silva',
      '234',
      'Centro Histórico',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90050-100',
    ],
    [
      228,
      'Rua Av. Farroupilha, nº 2881 – N. S. Graças  – Canoas, Rio Grande do Sul',
      'R. Farroupilha, 2881 - Nossa Sra. das Gracas, Canoas - RS, 92025, Brazil',
      '-29.9320352',
      '-51.166503',
      'Rua Farroupilha',
      '2881',
      'Nossa Senhora das Gracas',
      'Canoas',
      'Rio Grande do Sul',
      '92025',
    ],
    [
      229,
      'Rua Manoel Bernardes, nº 396 / Intersul  – Alvorada, Rio Grande do Sul',
      'R. Manoel Bernardes, 396 - Aparecida, Alvorada - RS, 94853-310, Brazil',
      '-30.0234312',
      '-51.0671911',
      'Rua Manoel Bernardes',
      '396',
      'Aparecida',
      'Alvorada',
      'Rio Grande do Sul',
      '94853-310',
    ],
    [
      230,
      'Rua 10, nº 52 – Loteamento Prata – Fátima – Canoas, Rio Grande do sul',
      'Parkshopping - Av. Farroupilha, 4545 - LJ 2041 - Mal. Rondon, Canoas - RS, 92020-475, Brazil',
      '-29.915197',
      '-51.1649284',
      'Avenida Farroupilha',
      '4545',
      'Marechal Rondon',
      'Canoas',
      'Rio Grande do Sul',
      '92020-475',
    ],
    [
      231,
      'Avenida Bento Gonçalves nº 164 / 502 Centro – Torres, Rio Grande do Sul',
      'Av. Bento Gonçalves, 164 - Tarumã, Viamão - RS, 94410-400, Brazil',
      '-30.08090979999999',
      '-51.0341761',
      'Avenida Bento Gonçalves',
      '164',
      'Tarumã',
      'Viamão',
      'Rio Grande do Sul',
      '94410-400',
    ],
    [
      232,
      'Rua X-14 nº 150 – Bairro Colina – Guaíba, Rio Grande do Sul',
      'R. X 14, 150 - Colina, Guaíba - RS, 92500-000, Brazil',
      '-30.1276159',
      '-51.3461583',
      'Rua X 14',
      '150',
      'Colina',
      'Guaíba',
      'Rio Grande do Sul',
      '92500-000',
    ],
    [
      233,
      'Bairro Boa Vista – Ijuí, Rio Grande do sul',
      'Boa Vista, Ijuí - RS, 98700-000, Brazil',
      '-28.372332',
      '-53.923811',
      '',
      '',
      'Boa Vista',
      'Ijuí',
      'Rio Grande do Sul',
      '98700-000',
    ],
    [
      234,
      'Rua Narciso Silva nº 1570 – Centro – Capão do Leão, Rio Grande do sul',
      'Av. Narciso Silva, 1570 - Centro, Capão do Leão - RS, 96160-000, Brazil',
      '-31.7637038',
      '-52.4994996',
      'Avenida Narciso Silva',
      '1570',
      'Centro',
      'Capão do Leão',
      'Rio Grande do Sul',
      '96160-000',
    ],
    [
      235,
      'Rua Rio Grande do Sul nº 2820 – Mathias Velho, Rio Grande do Sul',
      'R. Rio Grande do Sul, 2820 - Mathias Velho, Canoas - RS, 92330-160, Brazil',
      '-29.9011728',
      '-51.2190695',
      'Rua Rio Grande do Sul',
      '2820',
      'Mathias Velho',
      'Canoas',
      'Rio Grande do Sul',
      '92330-160',
    ],
    [
      236,
      'Rua Clodovil Guilherme Zanata nº 210  - Rosário, Caxias do Sul',
      'Caxias do Sul - Galópolis, Caxias do Sul - RS, Brazil',
      '-29.1634031',
      '-51.1796683',
      '',
      '',
      '',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '',
    ],
    [
      237,
      'Rua Aquarela do Brasil nº 165 – São Lucas – Viamão, Rio Grande do Sul',
      'R. Aquarela do Brasil, 165 - São Lucas, Viamão - RS, 94450-000, Brazil',
      '-30.091011',
      '-51.0645584',
      'Rua Aquarela do Brasil',
      '165',
      'São Lucas',
      'Viamão',
      'Rio Grande do Sul',
      '94450-000',
    ],
    [
      238,
      'Rua Santa Clara nº 842, Guaíba, Rio Grande do sul',
      'Av. Santa Clara, 842 - Jardim dos Lagos, Guaíba - RS, 92500-000, Brazil',
      '-30.1100222',
      '-51.3621916',
      'Avenida Santa Clara',
      '842',
      'Jardim dos Lagos',
      'Guaíba',
      'Rio Grande do Sul',
      '92500-000',
    ],
    [
      239,
      'Av. Antônio Giudice nº 250 – Protásio Alves – Porto Alegre, Rio Grande do Sul',
      'Av. Antônio Giudice, 250 - Petrópolis, Porto Alegre - RS, 91260-040, Brazil',
      '-30.0371211',
      '-51.1241893',
      'Avenida Antônio Giudice',
      '250',
      'Petrópolis',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91260-040',
    ],
    [
      240,
      'Rua da Represa nº 130 – Partenon – Porto Alegre, Rio Grande do Sul',
      'R. da Represa, 130 - São José, Porto Alegre - RS, 91520-680, Brazil',
      '-30.0791686',
      '-51.1707669',
      'Rua da Represa',
      '130',
      'São José',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91520-680',
    ],
    [
      241,
      'Av. Ferreira Viana,2886/401 bloco 1 Areal, Pelotas, Rio Grande do Sul',
      'Av. Ferreira Viana, 2886 - 1 - Areal, Pelotas - RS, 96085-000, Brazil',
      '-31.7572632',
      '-52.3051431',
      'Avenida Ferreira Viana',
      '2886',
      'Areal',
      'Pelotas',
      'Rio Grande do Sul',
      '96085-000',
    ],
    [
      242,
      'rua Cedro,262, Maria Regina, Alvorada, Rio Grande do Sul',
      'R. Cedro, 262 - Maria Regina, Alvorada - RS, 94828-140, Brazil',
      '-29.9971983',
      '-51.06175529999999',
      'Rua Cedro',
      '262',
      'Maria Regina',
      'Alvorada',
      'Rio Grande do Sul',
      '94828-140',
    ],
    [
      243,
      'r. Pinto Bandeira, 1410, Junção, Rio Grande, Rio Grande do Sul',
      'R. Pinto Bandeira, 1410 - Vila Juncao, Rio Grande - RS, 96212-470, Brazil',
      '-32.0533546',
      '-52.1356876',
      'Rua Pinto Bandeira',
      '1410',
      'Vila Juncao',
      'Rio Grande',
      'Rio Grande do Sul',
      '96212-470',
    ],
    [
      244,
      'rua Adalberto Wortmann,95, São Lucas, Canela, Rio Grande do Sul',
      'R. Adalberto Wortmann, 95 - São Lucas, Canela - RS, 95680-000, Brazil',
      '-29.3499652',
      '-50.79464669999999',
      'Rua Adalberto Wortmann',
      '95',
      'São Lucas',
      'Canela',
      'Rio Grande do Sul',
      '95680-000',
    ],
    [
      245,
      'Morro do Pedro Rosa, Interior, Tabaí, Rio Grande do Sul',
      'BR-287, Tabaí - RS, 95863-000, Brazil',
      '-29.6889219',
      '-51.7337796',
      'BR-287',
      '',
      '',
      'Tabaí',
      'Rio Grande do Sul',
      '95863-000',
    ],
    [
      246,
      'Morro Alto, 510, Aberta dos Morros, Porto Alegre , Rio Grande do Sul',
      'R. Morro Alto, 510 - Parque Urbano, Porto Alegre - RS, 91751-650, Brazil',
      '-30.1362439',
      '-51.210904',
      'Rua Morro Alto',
      '510',
      'Parque Urbano',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91751-650',
    ],
    [
      247,
      'BR 116 Km 28 RASIP, Vacaria, Rio Grande do Sul',
      'Rod BR 116 Km33 s/n Zona Rural, Vacaria - RS, 95200-000, Brazil',
      '-28.4697099',
      '-50.8911395',
      '',
      '',
      '',
      'Vacaria',
      'Rio Grande do Sul',
      '95200-000',
    ],
    [
      248,
      'Lombas, Cantão das Lombas - viamão, Rio Grande do Sul',
      'Lombas, Santo Antônio da Patrulha - RS, 95500-000, Brazil',
      '-29.916667',
      '-50.5',
      '',
      '',
      '',
      'Santo Antônio da Patrulha',
      'Rio Grande do Sul',
      '95500-000',
    ],
    [
      249,
      'rua E, nº1134 - bairro Arco ìris - Santa Maria, Rio Grande do sul',
      'Arco Íris, Pelotas - RS, Brazil',
      '-31.7152626',
      '-52.2921816',
      '',
      '',
      'Arco Íris',
      'Pelotas',
      'Rio Grande do Sul',
      '',
    ],
    [
      250,
      'r. Ismael Simões Lopes, 325, Fragata - Pelotas, Rio Grande do Sul',
      'R. Ismael Simões Lopes, 325 - Fragata, Pelotas - RS, 96030-670, Brazil',
      '-31.7607532',
      '-52.37164929999999',
      'Rua Ismael Simões Lopes',
      '325',
      'Fragata',
      'Pelotas',
      'Rio Grande do Sul',
      '96030-670',
    ],
    [
      251,
      'r. Rio de Janeiro, 289 - Delta do Jacuí - Eldorado do Sul, Rio Grande do Sul',
      'Parque Estadual Delta do Jacuí, Eldorado do Sul - RS, 92990-000, Brazil',
      '-29.9708148',
      '-51.3272451',
      '',
      '',
      '',
      'Eldorado do Sul',
      'Rio Grande do Sul',
      '92990-000',
    ],
    [
      252,
      'r. Batuíra, 205, bairro Porto Verde -Alvorada, Rio Grande do Sul',
      'R. Batuíra, 205 - Jardim Algarve, Alvorada - RS, 94858-330, Brazil',
      '-30.028562',
      '-51.0715999',
      'Rua Batuíra',
      '205',
      'Jardim Algarve',
      'Alvorada',
      'Rio Grande do Sul',
      '94858-330',
    ],
    [
      253,
      'rua Ventura Pinto,295, Porto Alegre, Rio Grande do sul',
      'R. Ventura Pinto, 295 - Belém Velho, Porto Alegre - RS, 91712-050, Brazil',
      '-30.1137208',
      '-51.1852359',
      'Rua Ventura Pinto',
      '295',
      'Belém Velho',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91712-050',
    ],
    [
      254,
      'Av 21 de abril, 1470 - Sarandi, Porto Alegre, Rio Grande do Sul',
      'Av. 21 de Abril, 1470 - Sarandi, Porto Alegre - RS, 91120-630, Brazil',
      '-29.97925',
      '-51.13034409999999',
      'Avenida 21 de Abril',
      '1470',
      'Sarandi',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91120-630',
    ],
    [
      255,
      'Travessa São Caetano, 72, Botafogo - Bento Gonçalves , Rio Grande do Sul',
      'R. São Caetano, 72 - Botafogo, Bento Gonçalves - RS, 95700-000, Brazil',
      '-29.174321',
      '-51.5137552',
      'Rua São Caetano',
      '72',
      'Botafogo',
      'Bento Gonçalves',
      'Rio Grande do Sul',
      '95700-000',
    ],
    [
      256,
      'RUA EGIDIO PICOLI, 92, Protásio Alves - Porto Alegre, Rio Grande do Sul',
      'Rua Egidio Piccoli, 92 - Alto Petrópolis, Porto Alegre - RS, 91263-200, Brazil',
      '-30.0439298',
      '-51.1058646',
      'Rua Egidio Piccoli',
      '92',
      'Alto Petrópolis',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91263-200',
    ],
    [
      257,
      'r. Teotanio Vilela,139, Macedo - Alegrete, Rio Grande do Sul',
      'Macedo, Alegrete - RS, 97542, Brazil',
      '-29.7823031',
      '-55.7999184',
      '',
      '',
      'Macedo',
      'Alegrete',
      'Rio Grande do Sul',
      '97542',
    ],
    [
      258,
      'r. Altemar Teles de Sozua, 77, Centro, Canela, Rio Grande do Sul',
      'R. Altenor Teles de Souza, Canela - RS, 95680-000, Brazil',
      '-29.3611189',
      '-50.8164904',
      'Rua Altenor Teles de Souza',
      '',
      '',
      'Canela',
      'Rio Grande do Sul',
      '95680-000',
    ],
    [
      259,
      'r. Maranhão, 54, Universitário, Lajeado, Rio Grande do Sul',
      'R. Maranhão, 54 - Universitário, Lajeado - RS, 95914-720, Brazil',
      '-29.4372108',
      '-51.968207',
      'Rua Maranhão',
      '54',
      'Universitário',
      'Lajeado',
      'Rio Grande do Sul',
      '95914-720',
    ],
    [
      260,
      'r. Carlos Baretta, 27, Industrial, Farroupilha, Rio Grande do Sul',
      'R. Carlos Bareta, 27 - América, Farroupilha - RS, 95180-000, Brazil',
      '-29.2379114',
      '-51.3227416',
      'Rua Carlos Bareta',
      '27',
      'América',
      'Farroupilha',
      'Rio Grande do Sul',
      '95180-000',
    ],
    [
      261,
      'r. Augusto Peccin, 212, Bela Vista, Farroupilha, Rio Grande do Sul',
      'R. Augusto Pessin - Bela Vista, Farroupilha - RS, 95173-022, Brazil',
      '-29.21358279999999',
      '-51.3527347',
      'Rua Augusto Pessin',
      '',
      'Bela Vista',
      'Farroupilha',
      'Rio Grande do Sul',
      '95173-022',
    ],
    [
      262,
      'r. Barreto Vianna, 639, Vila Lanza, Viamão, Rio Grande do sul',
      'Av. Pref. Barreto Viana, 639 - Cecília, Viamão - RS, 94475-750, Brazil',
      '-30.0740345',
      '-51.1028059',
      'Avenida Prefeito Barreto Viana',
      '639',
      'Cecília',
      'Viamão',
      'Rio Grande do Sul',
      '94475-750',
    ],
    [
      263,
      'r. Pedro Petry, 240, Rondônia, Novo Hamburgo, Rio Grande do Sul',
      'R. pedro Petry, 240 - Rondônia, Novo Hamburgo - RS, 93415-620, Brazil',
      '-29.707042',
      '-51.122587',
      'Rua pedro Petry',
      '240',
      'Rondônia',
      'Novo Hamburgo',
      'Rio Grande do Sul',
      '93415-620',
    ],
    [
      264,
      'r. Herbert José de Souza - Menino Deus - Santa Cruz do Sul, Rio Grande do Sul',
      'Menino Deus, Santa Cruz do Sul - RS, Brazil',
      '-29.7475946',
      '-52.4362704',
      '',
      '',
      'Menino Deus',
      'Santa Cruz do Sul',
      'Rio Grande do Sul',
      '',
    ],
    [
      265,
      'r. Dr. Ângelo Athanasio, 49, Rincão, São Francisco de Paula, Rio Grande do Sul',
      'Tv. Dr. Ângelo Athanasio, São Francisco de Paula - RS, 95400-000, Brazil',
      '-29.446443',
      '-50.569885',
      'Travessa Doutor Ângelo Athanasio',
      '',
      '',
      'São Francisco de Paula',
      'Rio Grande do Sul',
      '95400-000',
    ],
    [
      266,
      'Rua Carumbé, n° 217, Bom jesus - Porto Alegre, Rio Grande do Sul',
      'Rua Carumbé, 217 - Bom Jesus, Porto Alegre - RS, 91420-040, Brazil',
      '-30.0438469',
      '-51.1520443',
      'Rua Carumbé',
      '217',
      'Bom Jesus',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91420-040',
    ],
    [
      267,
      'Rua Madre Bárbara, nº 142, De Zorzi, Caxias do Sul, Rio Grande do sul',
      'R. Padre Raul Accorsi, 1117-1315 - De Lazzer, Caxias do Sul - RS, 95055, Brazil',
      '-29.160846',
      '-51.13340299999999',
      'Rua Padre Raul Accorsi',
      '1117-1315',
      'De Lazzer',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95055',
    ],
    [
      268,
      'Rua Gregório Kruker, nº 55, Centro, Erebango, Rio Grande do sul',
      'R. Gregório Kruker, 55, Erebango - RS, 99920-000, Brazil',
      '-27.8547375',
      '-52.302281',
      'Rua Gregório Kruker',
      '55',
      '',
      'Erebango',
      'Rio Grande do Sul',
      '99920-000',
    ],
    [
      269,
      'Rua Orfanotrófio, Beco 3, Nonoai, Porto Alegre, Rio Grande do sul',
      'Rua Orfanotrófio, 3 - Cristal, Porto Alegre - RS, Brazil',
      '-30.076746',
      '-51.2145814',
      'Rua Orfanotrófio',
      '3',
      'Cristal',
      'Porto Alegre',
      'Rio Grande do Sul',
      '',
    ],
    [
      270,
      'Rua Saldanha da Gama, n°85 apt°105, Harmonia, Canoas, Rio Grande do Sul',
      'R. Saldanha da Gama, 85 - 105 - Harmonia, Canoas - RS, 92310-630, Brazil',
      '-29.9177974',
      '-51.1900026',
      'Rua Saldanha da Gama',
      '85',
      'Harmonia',
      'Canoas',
      'Rio Grande do Sul',
      '92310-630',
    ],
    [
      271,
      'Rua Serra dos Nascentes, Encruzilhada do Sul, Rio Grande do sul',
      'R. Ten-Cel. Pereira, 801, Encruzilhada do Sul - RS, 96610-000, Brazil',
      '-30.5493387',
      '-52.532173',
      'Rua Tenente Coronel Pereira',
      '801',
      '',
      'Encruzilhada do Sul',
      'Rio Grande do Sul',
      '96610-000',
    ],
    [
      272,
      'Rua Carlos Scherer nº 70 / 10 , Fião , São leopoldo, Rio Grande do sul',
      'R. Carlos Scherer, 70 - Fião, São Leopoldo - RS, 93020-640, Brazil',
      '-29.7744197',
      '-51.148922',
      'Rua Carlos Scherer',
      '70',
      'Fião',
      'São Leopoldo',
      'Rio Grande do Sul',
      '93020-640',
    ],
    [
      273,
      'Rua Curupaiti, n° 93, Criltal, porto Alegre, Rio Grande do Sul',
      'R. Curupaiti, 93 - Cristal, Porto Alegre - RS, 90820-090, Brazil',
      '-30.080288',
      '-51.2381993',
      'Rua Curupaiti',
      '93',
      'Cristal',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90820-090',
    ],
    [
      274,
      'Rua Albion nº 811 , Passo Feijõ, Alvorada, Rio Grande do Sul',
      'R. Albion, 811 - Passo do Feijó, Alvorada - RS, 94810-041, Brazil',
      '-30.0072714',
      '-51.085297',
      'Rua Albion',
      '811',
      'Passo do Feijó',
      'Alvorada',
      'Rio Grande do Sul',
      '94810-041',
    ],
    [
      275,
      'Avenida Rio Grande do Sul nº 2820, Mathias velho, Canoas, Rio Grande do sul',
      'Av. Rio Grande do Sul, 2820 - Mathias Velho, Canoas - RS, 92330-001, Brazil',
      '-29.90183',
      '-51.20984800000001',
      'Avenida Rio Grande do Sul',
      '2820',
      'Mathias Velho',
      'Canoas',
      'Rio Grande do Sul',
      '92330-001',
    ],
    [
      276,
      'Rua Pio X nº 57 , bairro Bom Jesus, Porto Alegre, Rio Grande do Sul',
      'R. Pio X, 57 - Bom Jesus, Porto Alegre - RS, 91420-220, Brazil',
      '-30.04624939999999',
      '-51.157708',
      'Rua Pio X',
      '57',
      'Bom Jesus',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91420-220',
    ],
    [
      277,
      'Rua Castro Alves nº 502 - Prado, Santana do Livramento, Rio Grande do sul',
      'R. Castro Alves, 502 - Prado, Santana do Livramento - RS, 97572-640, Brazil',
      '-30.8771554',
      '-55.5360442',
      'Rua Castro Alves',
      '502',
      'Prado',
      'Santana do Livramento',
      'Rio Grande do Sul',
      '97572-640',
    ],
    [
      278,
      'Rua Princesa isabel, n° 87, São Vicente, Erechim, Rio Grande do Sul',
      'R. Princesa Isabel, 87 - Centro, Erechim - RS, 99700-222, Brazil',
      '-27.6433499',
      '-52.2750646',
      'Rua Princesa Isabel',
      '87',
      'Centro',
      'Erechim',
      'Rio Grande do Sul',
      '99700-222',
    ],
    [
      279,
      'Rua Ernesto Neugebauer, n°2470, Santo André, porto Alegre, Rio Grande do Sul',
      'Av. Ernesto Neugebauer, 2470 - Humaitá, Porto Alegre - RS, 90250-140, Brazil',
      '-29.9753721',
      '-51.178721',
      'Avenida Ernesto Neugebauer',
      '2470',
      'Humaitá',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90250-140',
    ],
    [
      280,
      'Rua Irmã Maria Trevisan, n°29, Navegantes, Porto Alegre, Rio Grande do Sul',
      'R. Irmã Maria José Trevisan, 29 - Farrapos, Porto Alegre - RS, 90250-430, Brazil',
      '-29.980241',
      '-51.19455900000001',
      'Rua Irmã Maria José Trevisan',
      '29',
      'Farrapos',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90250-430',
    ],
    [
      281,
      'Rua manuel Ferrador n°346, Passo das Pedras, Porto Alegre, Rio Grande do Sul',
      'R. Manoel Ferrador, 346 - Passo das Pedras, Porto Alegre - RS, 91230-370, Brazil',
      '-30.0167475',
      '-51.12593099999999',
      'Rua Manoel Ferrador',
      '346',
      'Passo das Pedras',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91230-370',
    ],
    [
      282,
      'Rua São Simão, n 2, Cristo Rei, Cachoeira do Sul, Rio Grande do Sul',
      'R. São Simão, 2 - Vila Carvalho, Cachoeira do Sul - RS, 96508-460, Brazil',
      '-30.04785579999999',
      '-52.8761978',
      'Rua São Simão',
      '2',
      'Vila Carvalho',
      'Cachoeira do Sul',
      'Rio Grande do Sul',
      '96508-460',
    ],
    [
      283,
      'Rua Conselheiro teixeira Jr., 229 casa 3, Cidade nova, Pelotas, Rio Grande do Sul',
      'R. Conselheiro Teixeira Júnior, 229 - casa 3 - Cidade Nova, Rio Grande - RS, 96211-540, Brazil',
      '-32.03593680000001',
      '-52.1143186',
      'Rua Conselheiro Teixeira Júnior',
      '229',
      'Cidade Nova',
      'Rio Grande',
      'Rio Grande do Sul',
      '96211-540',
    ],
    [
      284,
      'Rua Quintino Bocaiúva, n°556, São Miguel, Rio Grande, Rio Grande do Sul',
      'R. Quintino Bocaiúva, 556 - Vila Sao Miguel, Rio Grande - RS, 96212-490, Brazil',
      '-32.0578755',
      '-52.1509017',
      'Rua Quintino Bocaiúva',
      '556',
      'Vila Sao Miguel',
      'Rio Grande',
      'Rio Grande do Sul',
      '96212-490',
    ],
    [
      285,
      'Rua irmão José otão, 440, Leodoro Azeredo, Canela, Rio Grande do Sul',
      'R. Irmão José Otao, 440 - Vila Maggi, Canela - RS, 95680-000, Brazil',
      '-29.367477',
      '-50.8021624',
      'Rua Irmão José Otao',
      '440',
      'Vila Maggi',
      'Canela',
      'Rio Grande do Sul',
      '95680-000',
    ],
    [
      286,
      'Rua João jacob Bainy, n°401 A bloco 6, apt22, Três vendas, Pelotas, Rio Grande do Sul',
      'R. João Jacob Bainy, 401a - 6 - Tres Vendas, Pelotas - RS, 96065-340, Brazil',
      '-31.730148',
      '-52.3517314',
      'Rua João Jacob Bainy',
      '401a',
      'Tres Vendas',
      'Pelotas',
      'Rio Grande do Sul',
      '96065-340',
    ],
    [
      287,
      'Rua Boa Vista, n°52, Salgado Filho, Santa maria, Rio Grande do Sul',
      'R. Boa Vista, 52 - Salgado Filho, Santa Maria - RS, 97040-070, Brazil',
      '-29.6739112',
      '-53.82944740000001',
      'Rua Boa Vista',
      '52',
      'Salgado Filho',
      'Santa Maria',
      'Rio Grande do Sul',
      '97040-070',
    ],
    [
      288,
      'Rua Diário Popular, n° 411, Jardim Américo, Capão do Leão, Rio Grande do Sul',
      'R. Diário Popular, 411 - Jardim América, Capão do Leão - RS, 96160-000, Brazil',
      '-31.7519429',
      '-52.4307673',
      'Rua Diário Popular',
      '411',
      'Jardim América',
      'Capão do Leão',
      'Rio Grande do Sul',
      '96160-000',
    ],
    [
      289,
      'Rua Osório, n°1016, magistério, Balneário Pinhal, Rio Grande do Sul',
      'R. Osório, 1016 - Balneário Pinhal, RS, 95599-000, Brazil',
      '-30.2786308',
      '-50.25444170000001',
      'Rua Osório',
      '1016',
      'Balneário Pinhal',
      'Balneário Pinhal',
      'Rio Grande do Sul',
      '95599-000',
    ],
    [
      290,
      'Rua Hiário Gaio, n°1204, Santa Lúcia , Marau, Rio Grande do Sul',
      'R. Hilário Gaio, 1204 - Lot. Santa Tereza, Marau - RS, 99150-000, Brazil',
      '-28.419797',
      '-52.2112554',
      'R. Hilário Gaio',
      '1204',
      'Loteamento Santa Tereza',
      'Marau',
      'Rio Grande do Sul',
      '99150-000',
    ],
    [
      291,
      'Rua Paim Filho, n°89, planalto, Viamão, Rio Grande do Sul',
      'R. Paim Filho, 89 - Planalto, Viamão - RS, 94460, Brazil',
      '-30.1261748',
      '-51.08095369999999',
      'Rua Paim Filho',
      '89',
      'Planalto',
      'Viamão',
      'Rio Grande do Sul',
      '94460',
    ],
    [
      292,
      'Rua Duque de caxias, n°278, Encantado, Rio Grande do sul, Rio Grande do Sul',
      'R. Duque de Caxias, 278 - Lambari, Encantado - RS, 95960-000, Brazil',
      '-29.2365243',
      '-51.8904514',
      'Rua Duque de Caxias',
      '278',
      'Lambari',
      'Encantado',
      'Rio Grande do Sul',
      '95960-000',
    ],
    [
      293,
      'Rua E, n°160, Castelo Branco, Rio Grande, Rio Grande do Sul',
      'R. e, 160 - Castelo Branco, Rio Grande - RS, 96214-060, Brazil',
      '-32.075923',
      '-52.1769986',
      'Rua e',
      '160',
      'Castelo Branco',
      'Rio Grande',
      'Rio Grande do Sul',
      '96214-060',
    ],
    [
      294,
      'Rua Domenico Feoli, 375/304 bloco A1, Rubem berta, porto Alegre, Rio Grande do Sul',
      'R. Domênico Feoli, 375 - A1 - Porto, Porto Alegre - RS, 91250-580, Brazil',
      '-30.02649509999999',
      '-51.1051816',
      'Rua Domênico Feoli',
      '375',
      'Porto',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91250-580',
    ],
    [
      295,
      'Rua Riachuelo, n° 714, São Lucas, Viamão, Rio Grande do Sul',
      'R. Riachuelo, 714 - São Lucas, Viamão - RS, 94450-573, Brazil',
      '-30.0835032',
      '-51.0783701',
      'Rua Riachuelo',
      '714',
      'São Lucas',
      'Viamão',
      'Rio Grande do Sul',
      '94450-573',
    ],
    [
      296,
      "Rua João D'Andréa, n°3160, Pioneiro, Caxias do Sul, Rio Grande do Sul",
      "R. João d'Andréa, 3160 - Pioneiro, Caxias do Sul - RS, 95042, Brazil",
      '-29.1394921',
      '-51.1908168',
      "Rua João d'Andréa",
      '3160',
      'Pioneiro',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95042',
    ],
    [
      297,
      'Rua Hugo Fornier Luz, n°246,Fragata, Pelotas, Rio Grande do Sul',
      'R. Hugo Fournier Luz, 246 - Fragata, Pelotas - RS, 96040-100, Brazil',
      '-31.7474816',
      '-52.3702228',
      'Rua Hugo Fournier Luz',
      '246',
      'Fragata',
      'Pelotas',
      'Rio Grande do Sul',
      '96040-100',
    ],
    [
      298,
      'Rua Condor, n°695, Santa Cecilia, Viamão, Rio Grande do sul',
      'R. Condor, 695 - Santa Cecília, Viamão - RS, 94475-600, Brazil',
      '-30.0622249',
      '-51.0898851',
      'Rua Condor',
      '695',
      'Santa Cecília',
      'Viamão',
      'Rio Grande do Sul',
      '94475-600',
    ],
    [
      299,
      'Av Santa Fe, Casa 87, Santa Fe, Caxias do Sul, Rio Grande do Sul',
      'Av. Santa Fé - Santa Fé, Caxias do Sul - RS, 95045-540, Brazil',
      '-29.12480639999999',
      '-51.1805919',
      'Avenida Santa Fé',
      '',
      'Santa Fé',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95045-540',
    ],
    [
      300,
      'Vinte Tres de Deembro, n°583, Umbu, Alvorada, Rio Grande do Sul',
      'R. Vinte e Três de Dezembro, 583 - Maria Regina, Alvorada - RS, 94834-414, Brazil',
      '-29.9982569',
      '-51.0508971',
      'Rua Vinte e Três de Dezembro',
      '583',
      'Maria Regina',
      'Alvorada',
      'Rio Grande do Sul',
      '94834-414',
    ],
    [
      301,
      'Rua Albion 811, Passo Feijo, Alvorada, Rio Grande do Sul',
      'R. Albion, 811 - Passo do Feijó, Alvorada - RS, 94810-041, Brazil',
      '-30.0072714',
      '-51.085297',
      'Rua Albion',
      '811',
      'Passo do Feijó',
      'Alvorada',
      'Rio Grande do Sul',
      '94810-041',
    ],
    [
      302,
      'Presidente Getulio vargas, 125, Jardim América, Capão do Leão, Rio Grande do Sul',
      'Av. Pres. Getúlio Vargas, 125 - Jardim América, Capão do Leão - RS, 96160-000, Brazil',
      '-31.7644167',
      '-52.4330262',
      'Avenida Presidente Getúlio Vargas',
      '125',
      'Jardim América',
      'Capão do Leão',
      'Rio Grande do Sul',
      '96160-000',
    ],
    [
      303,
      'Rua Cândido Batista Neto, Centro, Butiá, Rio Grande do sul',
      'R. Cândido Batista Neto - Cidade Alta, Butiá - RS, 96750-000, Brazil',
      '-30.1260585',
      '-51.9659239',
      'Rua Cândido Batista Neto',
      '',
      'Cidade Alta',
      'Butiá',
      'Rio Grande do Sul',
      '96750-000',
    ],
    [
      304,
      'Rua Vila Piccadilli, n°02, Casa da Pilcha, Igrejinha, Rio Grande do Sul',
      'R. Gen. Ernesto Dorneles, 577 - Centro, Igrejinha - RS, 95650-000, Brazil',
      '-29.5721817',
      '-50.7915585',
      'Rua General Ernesto Dorneles',
      '577',
      'Centro',
      'Igrejinha',
      'Rio Grande do Sul',
      '95650-000',
    ],
    [
      305,
      'Rua João Bravo Almeida, n°25, Rubem Berta, Porto Alegre, Rio Grande do Sul',
      'R. João Bravo de Almeida, 25 - Rubem Berta, Porto Alegre - RS, 91180-035, Brazil',
      '-30.0110495',
      '-51.124143',
      'Rua João Bravo de Almeida',
      '25',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91180-035',
    ],
    [
      306,
      'Rua Jorge Mello Guimarães, n°868, Belém Novo, Porto Alegre, Rio Grande do Sul',
      'Rua Jorge Mello Guimarães, 868 - Belém Novo, Porto Alegre - RS, 91780-020, Brazil',
      '-30.2089693',
      '-51.1832669',
      'Rua Jorge Mello Guimarães',
      '868',
      'Belém Novo',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91780-020',
    ],
    [
      307,
      'Rua Ascenção n°54, Centro, Porto Alegre, Rio Grande do Sul',
      'R. Ascenção, 54 - Cascata, Porto Alegre - RS, 91710-180, Brazil',
      '-30.0781515',
      '-51.1943754',
      'Rua Ascenção',
      '54',
      'Cascata',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91710-180',
    ],
    [
      308,
      'Av. Paul Harris 1/929-785, bairro Centro, Santa Cruz do Sul, Rio Grande do Sul',
      'Av. Paul Harris, 1 - Faxinal, Santa Cruz do Sul - RS, 96845, Brazil',
      '-29.7217884',
      '-52.4344467',
      'Avenida Paul Harris',
      '1',
      'Faxinal',
      'Santa Cruz do Sul',
      'Rio Grande do Sul',
      '96845',
    ],
    [
      309,
      'Rua Oito de março, n°352, Primavera, Esteio, Rio Grande do Sul',
      'R. 8 de Março, 352 - Parque Primavera, Esteio - RS, 93295-520, Brazil',
      '-29.86249279999999',
      '-51.1279173',
      'Rua 8 de Março',
      '352',
      'Parque Primavera',
      'Esteio',
      'Rio Grande do Sul',
      '93295-520',
    ],
    [
      310,
      'Estrada Municipal, n°700, Neópolis, Gravataí, Rio Grande do Sul',
      'Estrada Mun., 700 - Neópolis, Gravataí - RS, 94100-000, Brazil',
      '-29.9038605',
      '-51.0180136',
      'Estrada Municipal',
      '700',
      'Neópolis',
      'Gravataí',
      'Rio Grande do Sul',
      '94100-000',
    ],
    [
      311,
      'Rua João Correa, n°206, Cinco de maio, Montenegro, Rio Grande do Sul',
      'R. João Corrêa, 206 - Senai, Montenegro - RS, 95780-000, Brazil',
      '-29.6890092',
      '-51.4839739',
      'Rua João Corrêa',
      '206',
      'Senai',
      'Montenegro',
      'Rio Grande do Sul',
      '95780-000',
    ],
    [
      312,
      'Rua La Paz, n°248, Wolgien, Panambi, Rio Grande do Sul',
      'R. La Paz - Bairro Wolgien, Panambi - RS, 98280-000, Brazil',
      '-28.2925373',
      '-53.4811074',
      'Rua La Paz',
      '',
      'Bairro Wolgien',
      'Panambi',
      'Rio Grande do Sul',
      '98280-000',
    ],
    [
      313,
      'Rua São Judas Tadeu, n°205, Lomba do Pinheiro, Porto Alegre, Rio Grande do Sul',
      'R. São Judas Tadeu, 205 - Lomba do Pinheiro, Porto Alegre - RS, 91570-550, Brazil',
      '-30.1214817',
      '-51.10115889999999',
      'Rua São Judas Tadeu',
      '205',
      'Lomba do Pinheiro',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91570-550',
    ],
    [
      314,
      'Rua Antonio Pinto n°295, São Thomáz, São Jerônimo, Rio Grande do sul',
      'R. Antônio Oliveira Pinto, 295 - São Thomás, São Jerônimo - RS, 96700-000, Brazil',
      '-29.9635849',
      '-51.72286',
      'Rua Antônio Oliveira Pinto',
      '295',
      'São Thomás',
      'São Jerônimo',
      'Rio Grande do Sul',
      '96700-000',
    ],
    [
      315,
      'Rua João Vicente, 113, Lomba do Pinheiro, Porto Alegre, Rio Grande do Sul',
      'R. João Vicente, 113 - Lomba do Pinheiro, Porto Alegre - RS, 91560-160, Brazil',
      '-30.1083731',
      '-51.1112103',
      'Rua João Vicente',
      '113',
      'Lomba do Pinheiro',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91560-160',
    ],
    [
      316,
      'JAS nº 4760, Bloco L; aptº 447, Restinga, Porto Alegre, Rio Grande do Sul',
      'Restinga, Porto Alegre - RS, Brazil',
      '-30.15479869999999',
      '-51.1393006',
      '',
      '',
      'Restinga',
      'Porto Alegre',
      'Rio Grande do Sul',
      '',
    ],
    [
      317,
      'Vila Nova, Interior, Boqueirão do Sul, Rio Grande do Sul',
      'Vila Nova, Porto Alegre - RS, Brazil',
      '-30.1175585',
      '-51.2068058',
      '',
      '',
      'Vila Nova',
      'Porto Alegre',
      'Rio Grande do Sul',
      '',
    ],
    [
      318,
      'Rua Jango Castro, n°1037, Santa Marta, Camaquã, Rio Grande do Sul',
      'R. Cap. Jango Castro, 1037 - Bom Sucesso, Camaquã - RS, 96180-000, Brazil',
      '-30.8399498',
      '-51.82210860000001',
      'Rua Capitão Jango Castro',
      '1037',
      'Bom Sucesso',
      'Camaquã',
      'Rio Grande do Sul',
      '96180-000',
    ],
    [
      319,
      'Rua Paul Harris, n°785, Centro, Santa Cruz do Sul, Rio Grande do Sul',
      'Av. Paul Harris, 785 - Centro, Santa Cruz do Sul - RS, 96810-408, Brazil',
      '-29.727109',
      '-52.4303234',
      'Avenida Paul Harris',
      '785',
      'Centro',
      'Santa Cruz do Sul',
      'Rio Grande do Sul',
      '96810-408',
    ],
    [
      320,
      'Rua São Carlos, n°722, Urlândia, Santa Maria, Rio Grande do sul',
      'R. São Carlos, 722 - Urlândia, Santa Maria - RS, 97070-610, Brazil',
      '-29.713757',
      '-53.8227322',
      'Rua São Carlos',
      '722',
      'Urlândia',
      'Santa Maria',
      'Rio Grande do Sul',
      '97070-610',
    ],
    [
      321,
      'Rua Olintho Camassola, 460 - Parada Cristal - 95065056 - Caxias do Sul, Rio Grande do Sul',
      'Rua Olintho Camassola - Parada Cristal, Caxias do Sul - RS, 95065-058, Brazil',
      '-29.0791462',
      '-51.1084196',
      '',
      '',
      'Parada Cristal',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95065-058',
    ],
    [
      322,
      'Rua Alceu Sabino 283 - Bairro Tancredo Neves - Bento Gonçalves, Rio Grande do Sul',
      'R. Alceu Sábino, 283 - Conceição, Bento Gonçalves - RS, 95701-094, Brazil',
      '-29.168085',
      '-51.5324032',
      'Rua Alceu Sábino',
      '283',
      'Conceição',
      'Bento Gonçalves',
      'Rio Grande do Sul',
      '95701-094',
    ],
    [
      323,
      'Rua Júlio de Castilhos, nº 1270, Tarragot , Uruguaiana, Rio Grande do Sul',
      'R. Júlio de Castilhos, 1270 - Centro, Uruguaiana - RS, 97510-311, Brazil',
      '-29.7614456',
      '-57.1015585',
      'Rua Júlio de Castilhos',
      '1270',
      'Centro',
      'Uruguaiana',
      'Rio Grande do Sul',
      '97510-311',
    ],
    [
      324,
      'Rua Paulo Ribeiro Bittencourt, 11, Belém Velho, Porto Alegre, Rio Grande do Sul',
      'R. Paulo Ribeiro de Bitencourt, 11 - Belém Velho, Porto Alegre - RS, 91787-281, Brazil',
      '-30.1129924',
      '-51.167219',
      'Rua Paulo Ribeiro de Bitencourt',
      '11',
      'Belém Velho',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91787-281',
    ],
    [
      325,
      'Rua Eduardo Ferreira de Castilhos, 435, Lot. Nossa Sra. Caravaggio II, Caxias do Sul, Rio Grande do Sul',
      'R. Eduardo Ferreira de Castilhos, 435 - Nossa Sra. das Graças, Caxias do Sul - RS, 95095, Brazil',
      '-29.2030843',
      '-51.192135',
      'Rua Eduardo Ferreira de Castilhos',
      '435',
      'Nossa Senhora das Graças',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95095',
    ],
    [
      326,
      'rua Dona úrsula, 882, bairro Centro, Cambará do Sul, Rio Grande do Sul',
      'R. Dona Úrsula, 882, Cambará do Sul - RS, 95480-000, Brazil',
      '-29.0496417',
      '-50.1517407',
      'Rua Dona Úrsula',
      '882',
      '',
      'Cambará do Sul',
      'Rio Grande do Sul',
      '95480-000',
    ],
    [
      327,
      'rua 23, nº64, bairro V. Brás, São Leopoldo, Rio Grande do Sul',
      'R. Manoel José Brás - Santos Dumont, São Leopoldo - RS, Brazil',
      '-29.7432538',
      '-51.1383766',
      'Rua Manoel José Brás',
      '',
      'Santos Dumont',
      'São Leopoldo',
      'Rio Grande do Sul',
      '',
    ],
    [
      328,
      'rua Darci Rodrigues Bello, nº 3172, São Jorge, Bage, Rio Grande do Sul',
      'R. Darci Rodrigues Bello, 3172 - São Jorge, Bagé - RS, 96408-630, Brazil',
      '-31.3064717',
      '-54.1059323',
      'Rua Darci Rodrigues Bello',
      '3172',
      'São Jorge',
      'Bagé',
      'Rio Grande do Sul',
      '96408-630',
    ],
    [
      329,
      'Rua Recanto do Chimarrão, 47, Sarandi, Porto Alegre, Rio Grande do Sul',
      'Beco Recanto do Chimarrão, 47 - Sarandi, Porto Alegre - RS, 91130-680, Brazil',
      '-29.9901323',
      '-51.1129773',
      'Beco Recanto do Chimarrão',
      '47',
      'Sarandi',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91130-680',
    ],
    [
      330,
      'Rua Germano Paiva, 1537, Mundo Novo, Taquara, Rio Grande do Sul',
      'R. Germano Paiva, 1537, Taquara - RS, 95600-000, Brazil',
      '-29.6599122',
      '-50.7530714',
      'Rua Germano Paiva',
      '1537',
      '',
      'Taquara',
      'Rio Grande do Sul',
      '95600-000',
    ],
    [
      331,
      'Rua Eng. Chang, 819, Rio Branco, Canoas, Rio Grande do Sul',
      'R. Eng. Chang, 819 - Rio Branco, Canoas - RS, 92200-620, Brazil',
      '-29.953461',
      '-51.186017',
      'Rua Engenheiro Chang',
      '819',
      'Rio Branco',
      'Canoas',
      'Rio Grande do Sul',
      '92200-620',
    ],
    [
      332,
      'Rua Antonio Soldateli s/n, Loteamento Frane, Flores da Cunha, Rio Grande do Sul',
      'Estr. Antônio Soldatelli, Flores da Cunha - RS, 95270-000, Brazil',
      '-29.0250566',
      '-51.1669195',
      'Estrada Antônio Soldatelli',
      '',
      '',
      'Flores da Cunha',
      'Rio Grande do Sul',
      '95270-000',
    ],
    [
      333,
      'Rua Santa Rosa de Lima, 288, Rubem Berta, Porto Alegre, Rio Grande do sul',
      'Rua Santa Rosa de Lima, 288 - Rubem Berta, Porto Alegre - RS, 91170-590, Brazil',
      '-29.992633',
      '-51.0985495',
      'Rua Santa Rosa de Lima',
      '288',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91170-590',
    ],
    [
      334,
      'Rua Araucárias, 375, Rubem Berta, Porto Alegre, Rio Grande do Sul',
      'R. das Araucárias, 375 - Rubem Berta, Porto Alegre - RS, 91253, Brazil',
      '-30.0217847',
      '-51.08971409999999',
      'Rua das Araucárias',
      '375',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91253',
    ],
    [
      335,
      'Rua Porto Alegre, 174, Bela Vista II, Garibaldi, Rio Grande do Sul',
      'R. Pôrto Alegre, 174 - Bela Vista, Garibaldi - RS, 95720-000, Brazil',
      '-29.27124659999999',
      '-51.5156917',
      'Rua Pôrto Alegre',
      '174',
      'Bela Vista',
      'Garibaldi',
      'Rio Grande do Sul',
      '95720-000',
    ],
    [
      336,
      'Rua 3, 246, Guarida, São José do Norte, Rio Grande do Sul',
      'Guarida, São José do Norte - RS, 96225-000, Brazil',
      '-32.0148238',
      '-52.03544549999999',
      '',
      '',
      'Guarida',
      'São José do Norte',
      'Rio Grande do Sul',
      '96225-000',
    ],
    [
      337,
      'rua Ondina Machado, 149, Mário Quintana, Porto Alegre, Rio Grande do Sul',
      'R. Ondina Machado, 149 - Jardim Leopoldina, Porto Alegre - RS, 91250-670, Brazil',
      '-30.0213593',
      '-51.0923127',
      'Rua Ondina Machado',
      '149',
      'Jardim Leopoldina',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91250-670',
    ],
    [
      338,
      'Rua Gioconda Ricci, 187; São João - Passo Fundo, Rio Grande do Sul',
      'R. Gioconda Ricci, Passo Fundo - RS, Brazil',
      '-28.2952702',
      '-52.34741409999999',
      'Rua Gioconda Ricci',
      '',
      '',
      'Passo Fundo',
      'Rio Grande do Sul',
      '',
    ],
    [
      339,
      'Rua Emilio Lamb, 556; Bairro XV de Novembro - Igrejinha, Rio Grande do Sul',
      'R. Emílio Lamb, 556 - 15 De Novembro, Igrejinha - RS, 95650-000, Brazil',
      '-29.5905179',
      '-50.8089295',
      'Rua Emílio Lamb',
      '556',
      '15 De Novembro',
      'Igrejinha',
      'Rio Grande do Sul',
      '95650-000',
    ],
    [
      340,
      'Rua Lauro Marcondes do Nascimento, 67; Bairro Santa Rita- Marau, Rio Grande do Sul',
      'R. Santa Rita, 67 - Lot. Santa Rita, Marau - RS, 99150-000, Brazil',
      '-28.4689734',
      '-52.2053422',
      'Rua Santa Rita',
      '67',
      'Loteamento Santa Rita',
      'Marau',
      'Rio Grande do Sul',
      '99150-000',
    ],
    [
      341,
      'Rua Eng. Chang, 819; Rio Branco - Canoas, Rio Grande do Sul',
      'R. Eng. Chang, 819 - Rio Branco, Canoas - RS, 92200-620, Brazil',
      '-29.953461',
      '-51.186017',
      'Rua Engenheiro Chang',
      '819',
      'Rio Branco',
      'Canoas',
      'Rio Grande do Sul',
      '92200-620',
    ],
    [
      342,
      'Rua Nilo José Corte, 617; Bairro Desvio Rizzo - Caxias do Sul, Rio Grande do Sul',
      'R. Nilo José Côrte, 617 - Desvio Rizzo, Caxias do Sul - RS, 95110-785, Brazil',
      '-29.1916967',
      '-51.23813879999999',
      'Rua Nilo José Côrte',
      '617',
      'Desvio Rizzo',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95110-785',
    ],
    [
      343,
      'Rua Pinheiro, 26; Santa Tereza - Porto Alegre, Rio Grande do Sul',
      'R. Pinheiro Machado, 26 - Independência, Porto Alegre - RS, 90035-180, Brazil',
      '-30.0265382',
      '-51.2108277',
      'Rua Pinheiro Machado',
      '26',
      'Independência',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90035-180',
    ],
    [
      344,
      'Rua Onze, 217, Zona Portuária - Rio Grande, Rio Grande do Sul',
      'Rio Grande - RS, Brazil',
      '-32.0395116',
      '-52.101445',
      '',
      '',
      '',
      'Rio Grande',
      'Rio Grande do Sul',
      '',
    ],
    [
      345,
      'Rua Fiorelo Ozelame, 4, Bairro Humaitá, Bento Gonçalves, Rio Grande do Sul',
      'R. Fiorelo Ozelame, 4 - Humaitá, Bento Gonçalves - RS, 95700-000, Brazil',
      '-29.1538844',
      '-51.51613150000001',
      'Rua Fiorelo Ozelame',
      '4',
      'Humaitá',
      'Bento Gonçalves',
      'Rio Grande do Sul',
      '95700-000',
    ],
    [
      346,
      'Rua Laurelio Peruffo, 100, Bairro Vila Nova, Bento Gonçalves, Rio Grande do Sul',
      'R. Aurélio Perufo, 100 - Vila Nova, Bento Gonçalves - RS, 95700-000, Brazil',
      '-29.1595928',
      '-51.4929225',
      'Rua Aurélio Perufo',
      '100',
      'Vila Nova',
      'Bento Gonçalves',
      'Rio Grande do Sul',
      '95700-000',
    ],
    [
      347,
      'Rua Rio Grande do Sul, 3291 apt. 103, Bairro Mathias Velho, Canoas, Rio Grande do Sul',
      'Av. Rio Grande do Sul, 3291 - 103 - Mathias Velho, Canoas - RS, 92330-001, Brazil',
      '-29.9010958',
      '-51.21614959999999',
      'Avenida Rio Grande do Sul',
      '3291',
      'Mathias Velho',
      'Canoas',
      'Rio Grande do Sul',
      '92330-001',
    ],
    [
      348,
      'Rua Rui Barbosa, 154, Bairro Jardim América, Porto Alegre, Rio Grande do Sul',
      'Porto Alegre, RS, Brazil',
      '-30.0346471',
      '-51.2176584',
      '',
      '',
      '',
      'Porto Alegre',
      'Rio Grande do Sul',
      '',
    ],
    [
      349,
      'Rua Sagitarius, 556 apt 03, Bairro Cruzeiro, Caxias do Sul, Rio Grande do Sul',
      'R. Sagitarius, 556 - 03 - Cruzeiro, Caxias do Sul - RS, 95074-360, Brazil',
      '-29.171194',
      '-51.1390812',
      'Rua Sagitarius',
      '556',
      'Cruzeiro',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95074-360',
    ],
    [
      350,
      'Rua Juscelino Kubitschek de Oliveira, 45, Bairro Monte Carmelo, Caxias do Sul, Rio Grande do Sul',
      'R. Juscelino Kubitscheck de Oliveira, 45 - Desvio Rizzo, Caxias do Sul - RS, 95110-500, Brazil',
      '-29.1845119',
      '-51.2331209',
      'Rua Juscelino Kubitscheck de Oliveira',
      '45',
      'Desvio Rizzo',
      'Caxias do Sul',
      'Rio Grande do Sul',
      '95110-500',
    ],
    [
      351,
      'BR 101, Km 10, Bairro Porto Colônia, Dom Pedro Alcantara, Rio Grande do Sul',
      'Av. Guilherme Cléo Biasi, Dom Pedro de Alcântara - RS, 95568-000, Brazil',
      '-29.3871861',
      '-49.8379807',
      'Avenida Guilherme Cléo Biasi',
      '',
      '',
      'Dom Pedro de Alcântara',
      'Rio Grande do Sul',
      '95568-000',
    ],
    [
      352,
      'Serra das Nascentes s/n, Interior, Encruzilhada do Sul, Rio Grande do Sul',
      'Encruzilhada do Sul, RS, 96610-000, Brazil',
      '-30.5454936',
      '-52.5257016',
      '',
      '',
      '',
      'Encruzilhada do Sul',
      'Rio Grande do Sul',
      '96610-000',
    ],
    [
      353,
      'Rua Maximiliano de almeida, 1552, Bairro Oliveira, Lagoa Vermelha, Rio Grande do Sul',
      'R. Maximiliano de Almeida, 1552 - Oliveira, Lagoa Vermelha - RS, 95300-000, Brazil',
      '-28.218857',
      '-51.5217036',
      'Rua Maximiliano de Almeida',
      '1552',
      'Oliveira',
      'Lagoa Vermelha',
      'Rio Grande do Sul',
      '95300-000',
    ],
    [
      354,
      'Avenida Sem. Alberto Pasqualini, 3778/202 bloco D, Bairro Universitário, Lajeado, Rio Grande do Sul',
      'Av. Senador Alberto Pasqualini, 3778 - Universitário, Lajeado - RS, 95914-500, Brazil',
      '-29.4557704',
      '-51.9672674',
      'Avenida Senador Alberto Pasqualini',
      '3778',
      'Universitário',
      'Lajeado',
      'Rio Grande do Sul',
      '95914-500',
    ],
    [
      355,
      'Avenida Zeferino Costa, 3892, Bairro Pestano, Pelotas, Rio Grande do Sul',
      'Av. Zeferino Costa, 3892 - Tres Vendas, Pelotas - RS, 96070-480, Brazil',
      '-31.699222',
      '-52.321751',
      'Avenida Zeferino Costa',
      '3892',
      'Tres Vendas',
      'Pelotas',
      'Rio Grande do Sul',
      '96070-480',
    ],
    [
      356,
      'Rua Barão de Tramandaí, 334, Bairro Py Crespo, Pelotas, Rio Grande do Sul',
      'R. Barão de Tramandahy, 334 - Py Crespo, Pelotas - RS, 96065-240, Brazil',
      '-31.7214052',
      '-52.3453408',
      'Rua Barão de Tramandahy',
      '334',
      'Py Crespo',
      'Pelotas',
      'Rio Grande do Sul',
      '96065-240',
    ],
    [
      357,
      'Rua Vinte e Dois de Maio, 201 - Lot.Pestano, Bairro Três Vendas, Pelotas, Rio Grande do Sul',
      'R. Vinte e Dois, Pelotas - RS, 96081-250, Brazil',
      '-31.7427983',
      '-52.31106399999999',
      'Rua Vinte e Dois',
      '',
      '',
      'Pelotas',
      'Rio Grande do Sul',
      '96081-250',
    ],
    [
      358,
      'Rua Atílio Superti, 2076 Acesso B casa 64, Bairro Vila Nova, Porto Alegre, Rio Grande do Sul',
      'R. Atílio Superti, 2076 - B casa - Vila Nova, Porto Alegre - RS, 91751-360, Brazil',
      '-30.12698499999999',
      '-51.2173884',
      'Rua Atílio Superti',
      '2076',
      'Vila Nova',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91751-360',
    ],
    [
      359,
      'Rua Maria Flor Vieira, 94, Bairro Farrapos, Porto Alegre, Rio Grande do Sul',
      'R. Maria Flôr Viêira, 94 - Farrapos, Porto Alegre - RS, 90250-751, Brazil',
      '-29.9825277',
      '-51.1945389',
      'Rua Maria Flôr Viêira',
      '94',
      'Farrapos',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90250-751',
    ],
    [
      360,
      'Avenida Homero Guerreiro, 675, Bairro Costa e Silva, Porto Alegre, Rio Grande do Sul',
      'Av. Homero Guerreiro, 675 - Sarandi, Porto Alegre - RS, 91150-030, Brazil',
      '-30.0079031',
      '-51.1231417',
      'Avenida Homero Guerreiro',
      '675',
      'Sarandi',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91150-030',
    ],
    [
      361,
      'Travessa das Camélias, 213, Bairro Aparício Borges, Porto Alegre, Rio Grande do Sul',
      'Tv. das Camélias, 213 - Cel. Aparicio Borges, Porto Alegre - RS, 91510-200, Brazil',
      '-30.080268',
      '-51.1730816',
      'Travessa das Camélias',
      '213',
      'Coronel Aparicio Borges',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91510-200',
    ],
    [
      362,
      'Rua "O" nº 110, Bairro Vila Fátima, Porto Alegre, Rio Grande do Sul',
      'R. O, 110 - Rubem Berta, Porto Alegre - RS, 91160, Brazil',
      '-29.9937544',
      '-51.1036532',
      'Rua O',
      '110',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91160',
    ],
    [
      363,
      'Rua D, 70, Bairro Santa Rosa de Lima, Porto Alegre, Rio Grande do Sul',
      'Rua Santa Rosa de Lima, 70 - Rubem Berta, Porto Alegre - RS, 91170-590, Brazil',
      '-29.991539',
      '-51.0983034',
      'Rua Santa Rosa de Lima',
      '70',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91170-590',
    ],
    [
      364,
      'Rua dos Mayas, 1491, Bairro Rubem Berta, Porto Alegre, Rio Grande do Sul',
      'R. dos Maias, 1491 - Rubem Berta, Porto Alegre - RS, 91170-200, Brazil',
      '-30.00093609999999',
      '-51.0974586',
      'Rua dos Maias',
      '1491',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91170-200',
    ],
    [
      365,
      'Rua Liberal, 810, Bairro Tristeza, Porto Alegre, Rio Grande do Sul',
      'R. Liberal, 810 - Tristeza, Porto Alegre - RS, 91920-680, Brazil',
      '-30.1151628',
      '-51.2454498',
      'Rua Liberal',
      '810',
      'Tristeza',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91920-680',
    ],
    [
      366,
      'Rua Paul Harris, 785, Centro, Santa Cruz do Sul, Rio Grande do Sul',
      'Av. Paul Harris, 785 - Centro, Santa Cruz do Sul - RS, 96810-408, Brazil',
      '-29.727109',
      '-52.4303234',
      'Avenida Paul Harris',
      '785',
      'Centro',
      'Santa Cruz do Sul',
      'Rio Grande do Sul',
      '96810-408',
    ],
    [
      367,
      'Rua Caldas Junior, 153, Bairro Passo das Pedras, Santa Maria, Rio Grande do Sul',
      "R. Caldas Júnior, 153 - Passo D'areia, Santa Maria - RS, 97020-100, Brazil",
      '-29.685475',
      '-53.83345490000001',
      'Rua Caldas Júnior',
      '153',
      "Passo D'areia",
      'Santa Maria',
      'Rio Grande do Sul',
      '97020-100',
    ],
    [
      368,
      'Rua Ivo Rodrigues, 12, Bairro Chácara do Sol, Uruguaiana, Rio Grande do Sul',
      'R. Ivo Rodrigues, 12 - Lot. Chacaras do Sol, Uruguaiana - RS, 97509-340, Brazil',
      '-29.7870606',
      '-57.0594639',
      'Rua Ivo Rodrigues',
      '12',
      'Loteamento Chacaras do Sol',
      'Uruguaiana',
      'Rio Grande do Sul',
      '97509-340',
    ],
    [
      369,
      'Rua Julio de Castilhos, 1610, Centro, Vacaria, Rio Grande do Sul',
      'R. Júlio de Castilhos, 1610 - Centro, Vacaria - RS, 95200-000, Brazil',
      '-28.5053233',
      '-50.9400136',
      'Rua Júlio de Castilhos',
      '1610',
      'Centro',
      'Vacaria',
      'Rio Grande do Sul',
      '95200-000',
    ],
    [
      370,
      'Rua Aimoré, 320, Bairro Indio Jari, Viamão, Rio Grande do Sul',
      'R. Aimorés, 320 - Parque Indio Jari, Viamão - RS, 94495, Brazil',
      '-30.0557226',
      '-51.09457219999999',
      'Rua Aimorés',
      '320',
      'Parque Indio Jari',
      'Viamão',
      'Rio Grande do Sul',
      '94495',
    ],
    [
      371,
      'Rua Rio de Janeiro, 201, Bairro São Cristóvão, Lajeado, Rio Grande do Sul',
      'R. Rio de Janeiro, 201 - São Cristóvão, Lajeado - RS, 95900-000, Brazil',
      '-29.445782',
      '-51.969414',
      'Rua Rio de Janeiro',
      '201',
      'São Cristóvão',
      'Lajeado',
      'Rio Grande do Sul',
      '95900-000',
    ],
    [
      372,
      'Rua Protasio Alves, 8666, Bairro Morro Santana, Porto Alegre, 90410004, Rio Grande do Sul',
      'Av. Protásio Alves, 8666 - Alto Petrópolis, Porto Alegre - RS, 90010-220, Brazil',
      '-30.0393613',
      '-51.1250784',
      'Avenida Protásio Alves',
      '8666',
      'Alto Petrópolis',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90010-220',
    ],
    [
      373,
      'Rua Fiorelo Piazetto, Bairro Santana, Estação, 99930000, Rio Grande do Sul',
      'Santana, Estação - RS, 99930-000, Brazil',
      '-27.9183008',
      '-52.2631041',
      '',
      '',
      'Santana',
      'Estação',
      'Rio Grande do Sul',
      '99930-000',
    ],
    [
      374,
      'Jeovane Salvati, 660, Bairro São Vicente, Gravataí, 94155-170, Rio Grande do Sul',
      'R. Giovani Salvati, 660 - São Vicente, Gravataí - RS, 94155-170, Brazil',
      '-29.92398589999999',
      '-51.0167207',
      'Rua Giovani Salvati',
      '660',
      'São Vicente',
      'Gravataí',
      'Rio Grande do Sul',
      '94155-170',
    ],
    [
      375,
      'Rua Paraiso, 36, Bairro Macedo, Alegrete, 97542500, Rio Grande do Sul',
      'R. Paraiso, 36 - Centro, Alegrete - RS, 97542-500, Brazil',
      '-29.78242729999999',
      '-55.7995112',
      'Rua Paraiso',
      '36',
      'Centro',
      'Alegrete',
      'Rio Grande do Sul',
      '97542-500',
    ],
    [
      376,
      'Invasão Oliveira, 24, Bairro Invasão, Santa Maria, 97043000, Rio Grande do Sul',
      'Av. Oliveira Mesquita, 24 - Salgado Filho, Santa Maria - RS, 97043-000, Brazil',
      '-29.6745533',
      '-53.8249793',
      'Avenida Oliveira Mesquita',
      '24',
      'Salgado Filho',
      'Santa Maria',
      'Rio Grande do Sul',
      '97043-000',
    ],
    [
      377,
      'Rua Doutor Aramante, 1242, Bairro Castilhos, Pelotas, 96020720, Rio Grande do Sul',
      'R. Dr. Amarante, 1242 - Centro, Pelotas - RS, 96020-720, Brazil',
      '-31.7553528',
      '-52.3507032',
      'Rua Doutor Amarante',
      '1242',
      'Centro',
      'Pelotas',
      'Rio Grande do Sul',
      '96020-720',
    ],
    [
      378,
      'rua Vinte e Dois de Maio, 201 - Lot.Pestano, Bairro Três Vendas, Pelotas, Rio Grande do Sul',
      'R. Vinte e Dois, Pelotas - RS, 96081-250, Brazil',
      '-31.7427983',
      '-52.31106399999999',
      'Rua Vinte e Dois',
      '',
      '',
      'Pelotas',
      'Rio Grande do Sul',
      '96081-250',
    ],
    [
      379,
      'Rua Cezário Lopes da Silva, 63, Bairro Rubem Berta, Porto Alegre, 91160340, Rio Grande do Sul',
      'Rua Cezário Lopes da Silva, 63 - Rubem Berta, Porto Alegre - RS, 91160-340, Brazil',
      '-29.9917526',
      '-51.0998552',
      'Rua Cezário Lopes da Silva',
      '63',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91160-340',
    ],
    [
      380,
      'Rua O, 110, Bairro Vila Fátima-Pinto, Porto Alegre, 91420130, Rio Grande do Sul',
      'R. O, 110 - Rubem Berta, Porto Alegre - RS, 91160, Brazil',
      '-29.9937544',
      '-51.1036532',
      'Rua O',
      '110',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91160',
    ],
    [
      381,
      'Rua Manoel Ferrador, 509, Bairro Passos das Pedras, Porto Alegre, 91230370, Rio Grande do Sul',
      'R. Manoel Ferrador, 509 - Passo das Pedras, Porto Alegre - RS, 91230-370, Brazil',
      '-30.0180608',
      '-51.1263026',
      'Rua Manoel Ferrador',
      '509',
      'Passo das Pedras',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91230-370',
    ],
    [
      382,
      'Rua Fernando Ferrari, 3099, Bairro Santa Brígida São Marcos, Santa Maria, 97010970, Rio Grande do Sul',
      'R. Fernando Ferrari, Santa Maria - RS, Brazil',
      '-29.6788154',
      '-53.6900169',
      'Rua Fernando Ferrari',
      '',
      '',
      'Santa Maria',
      'Rio Grande do Sul',
      '',
    ],
    [
      383,
      'Rua Adelaide Basso Pasquali, 645, Bairro Sete Neves, Bento Gonçalves, 95700000, Rio Grande do Sul',
      'R. Adelaíde Basso Pasquali, 645 - Conceição, Bento Gonçalves - RS, 95700-000, Brazil',
      '-29.1675897',
      '-51.5325413',
      'Rua Adelaíde Basso Pasquali',
      '645',
      'Conceição',
      'Bento Gonçalves',
      'Rio Grande do Sul',
      '95700-000',
    ],
    [
      384,
      'Rua João Pessoa, 73, Bairro Centro, Charqueadas, 96745000, Rio Grande do Sul',
      'Alameda João Pessoa, 73 - Centro, Charqueadas - RS, 96745-000, Brazil',
      '-29.963261',
      '-51.6267808',
      'Alameda João Pessoa',
      '73',
      'Centro',
      'Charqueadas',
      'Rio Grande do Sul',
      '96745-000',
    ],
    [
      385,
      'Rua Monteiro Lobato, 125, Bairro Cabo Luís Quevedo, Uruguaiana, 97503625, Rio Grande do Sul',
      'R. Monteiro Lobato, 125 - Centro, Uruguaiana - RS, 97510-390, Brazil',
      '-29.7702459',
      '-57.1069802',
      'Rua Monteiro Lobato',
      '125',
      'Centro',
      'Uruguaiana',
      'Rio Grande do Sul',
      '97510-390',
    ],
    [
      386,
      'Avenida Elisa, 504/03, Bairro São Vicente, Gravataí, 94060010, Rio Grande do Sul',
      'Av. Elisa, 504 - São Vicente, Gravataí - RS, 94060-010, Brazil',
      '-29.9376356',
      '-51.0586651',
      'Avenida Elisa',
      '504',
      'São Vicente',
      'Gravataí',
      'Rio Grande do Sul',
      '94060-010',
    ],
    [
      387,
      'Rua Santa Vitória, 234, Bairro Santo Onofre, Viamão, 94445360, Rio Grande do Sul',
      'R. Santa Vitória, 234 - Santo Onofre, Viamão - RS, 94445-360, Brazil',
      '-30.0986906',
      '-51.0581296',
      'Rua Santa Vitória',
      '234',
      'Santo Onofre',
      'Viamão',
      'Rio Grande do Sul',
      '94445-360',
    ],
    [
      388,
      'Rua 14, 132, Bairro Pedras Brancas, Guaíba, 92722380, Rio Grande do Sul',
      'R. Quatorze, 132 - Pedras Brancas, Guaíba - RS, 92722-380, Brazil',
      '-30.16558599999999',
      '-51.4043424',
      'Rua Quatorze',
      '132',
      'Pedras Brancas',
      'Guaíba',
      'Rio Grande do Sul',
      '92722-380',
    ],
    [
      389,
      'Amaral Ferrador, Bairro Centro, Amaral Ferrador, 96635000, Rio Grande do Sul',
      'Amaral Ferrador, RS, 96635-000, Brazil',
      '-30.8760779',
      '-52.251476',
      '',
      '',
      '',
      'Amaral Ferrador',
      'Rio Grande do Sul',
      '96635-000',
    ],
    [
      390,
      'End Almirante Saldanha, 190, Bairro VI Ângela Borella, Marau, 99150000, Rio Grande do Sul',
      'R. Alm. Saldanha, 190 - Bairro Vila Rigo, Marau - RS, 99150-000, Brazil',
      '-28.4530433',
      '-52.1956688',
      'Rua Almirante Saldanha',
      '190',
      'Bairro Vila Rigo',
      'Marau',
      'Rio Grande do Sul',
      '99150-000',
    ],
    [
      391,
      'Tv Dinarte Ventura, 53, Bairro Formoza, Alvorada, 94818330, Rio Grande do Sul',
      'Tv. Dinarte Ventura, 53 - Formoza, Alvorada - RS, 94814-150, Brazil',
      '-30.0055992',
      '-51.06829949999999',
      'Travessa Dinarte Ventura',
      '53',
      'Formoza',
      'Alvorada',
      'Rio Grande do Sul',
      '94814-150',
    ],
    [
      392,
      'Rua Dália, 100, Bairro Santa Tereza, Porto Alegre, 90820238, Rio Grande do Sul',
      'R. Dália, 100 - Cristal, Porto Alegre - RS, 90820-260, Brazil',
      '-30.0880299',
      '-51.23259299999999',
      'Rua Dália',
      '100',
      'Cristal',
      'Porto Alegre',
      'Rio Grande do Sul',
      '90820-260',
    ],
    [
      393,
      'Rua Prudente de Morais, 828, Bairro Niteroi, Canoas, 92130410, Rio Grande do Sul',
      'R. Prudente de Moraes, 828 - Niterói, Canoas - RS, 92130-410, Brazil',
      '-29.9581755',
      '-51.1676687',
      'Rua Prudente de Moraes',
      '828',
      'Niterói',
      'Canoas',
      'Rio Grande do Sul',
      '92130-410',
    ],
    [
      394,
      'Avenida Heitor Vieira, 947/64, Bairro Belém Novo, Porto Alegre, 91780-000, Rio Grande do Sul',
      'Av. Heitor Viêira, 947 - Belém Novo, Porto Alegre - RS, 91780-118, Brazil',
      '-30.2133605',
      '-51.1791779',
      'Avenida Heitor Viêira',
      '947',
      'Belém Novo',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91780-118',
    ],
    [
      395,
      'Rua Sete de Setembro, 56, São Leopoldo, 93115-210, Rio Grande do Sul',
      'R. Sete de Setembro, 56 - Santos Dumont, São Leopoldo - RS, 93115-210, Brazil',
      '-29.7368539',
      '-51.1481972',
      'Rua Sete de Setembro',
      '56',
      'Santos Dumont',
      'São Leopoldo',
      'Rio Grande do Sul',
      '93115-210',
    ],
    [
      396,
      'General Candido Mariano da Silva Rondon, Bairro Rondônia, Novo Hamburgo, 93415500, Rio Grande do Sul',
      'R. Gen. Cândido Mariano da Silva Rondon - Rondônia, Novo Hamburgo - RS, 93415-500, Brazil',
      '-29.7105738',
      '-51.114786',
      'Rua General Cândido Mariano da Silva Rondon',
      '',
      'Rondônia',
      'Novo Hamburgo',
      'Rio Grande do Sul',
      '93415-500',
    ],
    [
      397,
      'Maria Dorvalina Borges, 282, Bairro Santa Rosa de Lima, Porto Alegre, 91160240, Rio Grande do Sul',
      'R. Maria Dorvalina Borges, 282 - Rubem Berta, Porto Alegre - RS, 91160-240, Brazil',
      '-29.9963691',
      '-51.1029578',
      'Rua Maria Dorvalina Borges',
      '282',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91160-240',
    ],
    [
      398,
      'Rua Antonio Onofre da Silveira, Bairro Restinga, Porto Alegre, 91790510, Rio Grande do Sul',
      'R. Antônio Onófre da Silveira - Restinga, Porto Alegre - RS, 91790-510, Brazil',
      '-30.159839',
      '-51.143126',
      'Rua Antônio Onófre da Silveira',
      '',
      'Restinga',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91790-510',
    ],
    [
      399,
      'Sertão, Bairro Interior, Caraá, 95515000, Rio Grande do Sul',
      'Caraá, RS, 95515-000, Brazil',
      '-29.7921084',
      '-50.4247294',
      '',
      '',
      '',
      'Caraá',
      'Rio Grande do Sul',
      '95515-000',
    ],
    [
      400,
      'Rua Lorena do Canto Pereira, 139, Bairro Rubem Berta, Porto Alegre, 91160082, Rio Grande do Sul',
      'R. Lorena do Canto Pereira, 139 - Rubem Berta, Porto Alegre - RS, 91160, Brazil',
      '-29.996286',
      '-51.1054722',
      'Rua Lorena do Canto Pereira',
      '139',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91160',
    ],
    [
      401,
      'Avenida Bernardino Silveira de Amorim, 4080, Bairro Sarandi, Porto Alegre, 91140410, Rio Grande do Sul',
      'Av. Bernardino Silveira Amorim, 4080 - Rubem Berta, Porto Alegre - RS, 91160-624, Brazil',
      '-30.0057312',
      '-51.0903088',
      'Avenida Bernardino Silveira Amorim',
      '4080',
      'Rubem Berta',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91160-624',
    ],
    [
      402,
      'Rua Professor Hedy Lund e Menezes, 45, Bairro Real, Santana Livramento, 97572076, Rio Grande do Sul',
      'Real, Santana do Livramento - RS, Brazil',
      '-30.8606869',
      '-55.5330434',
      '',
      '',
      'Real',
      'Santana do Livramento',
      'Rio Grande do Sul',
      '',
    ],
    [
      403,
      'Rua Dois Mil e Trinta e Seis, 28, Bairro Mario Quintana, Porto Alegre, 91250720, Rio Grande do Sul',
      'R. Dois Mil e Trinta e Seis, 28 - Mario Quintana, Porto Alegre - RS, 91250-720, Brazil',
      '-30.021252',
      '-51.095002',
      'Rua Dois Mil e Trinta e Seis',
      '28',
      'Mario Quintana',
      'Porto Alegre',
      'Rio Grande do Sul',
      '91250-720',
    ],
    [
      404,
      'Rua Luis Cardoso, 816, Bairro Vila Eunice Nova, Cachoeirinha, 94920350, Rio Grande do Sul',
      'R. Luis Cardoso, 816 - Vila Eunice Nova, Cachoeirinha - RS, 94920-350, Brazil',
      '-29.958973',
      '-51.1002633',
      'Rua Luis Cardoso',
      '816',
      'Vila Eunice Nova',
      'Cachoeirinha',
      'Rio Grande do Sul',
      '94920-350',
    ],
    [
      405,
      'Tamoio, 445, Bairro Niteroi, Canoas, 92120001, Rio Grande do Sul',
      'R. Tamôio, 445 - Niterói, Canoas - RS, 92120-000, Brazil',
      '-29.9578651',
      '-51.1686481',
      'Rua Tamôio',
      '445',
      'Niterói',
      'Canoas',
      'Rio Grande do Sul',
      '92120-000',
    ],
  ],
};

export default dataExample;
